// AUTO-GENERATED by scripts/build-release-notes.mjs from release-notes/*.md.
// Do not edit by hand; this file is gitignored and rebuilt on every addon build.
export default {
  "notes": [
    {
      "id": "9.16.3-grid-shorthands-win-over-empty-full-name-args",
      "version": "9.16.3",
      "title": "Grid shorthands win over empty full-name args",
      "date": "2026-10-16",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-668/grid-shorthand-args-dont-work-in-style-guide-demos",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Core::Container",
        "Spds::Layout::Grid::Container",
        "Spds::Layout::Variable"
      ],
      "capabilities": [],
      "services": [],
      "body": "The grid shorthands `@columns`, `@rows`, `@areas`, `@area`, `@row` and `@autoFlow` now take effect when the matching full-name arg (`@gridTemplateColumns`, `@gridTemplateRows`, `@gridTemplateAreas`, `@gridArea`, `@gridRow`, `@gridAutoFlow`) is an empty string or its default (`initial`), not only when it is missing. A full-name arg with a real value still wins.\n\nPreviously an empty full-name arg blocked the shorthand and emitted no custom property at all. This is why the shorthand controls did nothing on the style guide's grid demos, which seed every full-name arg. An empty full-name arg with no shorthand now emits its default, for example `--grid-template-columns: initial`, so it no longer inherits a parent grid's value.\n\nThe shorthands are also no longer written to the element as unused custom properties (`--columns`, `--rows`, `--areas`, `--area`, `--auto-flow`)."
    },
    {
      "id": "9.16.2-vite-safe-named-app-reexports",
      "version": "9.16.2",
      "title": "Vite-safe named app reexports",
      "date": "2026-10-16",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-644/emit-vite-safe-named-app-js-re-exports-instead-of-a-starutils",
      "tags": [
        "DS Maintenance"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "App-tree reexports for utils are now `export *` when the source module has no\ndefault export. `focus` and `constants/spacing` were still emitted as\n`export { default }`, which Vite/Rolldown rejects while bundling Telehealth.\n\nModules that publish a real default, such as `persistent-hash-table`, keep\n`export { default }`. Modules that publish a default and named exports, such as\n`component-validations` and `with-hidden-array-super`, re-export both.\n`export *` would drop the default, and `export { default }` alone would drop\nthe names. The `starUtils` filename allowlist is gone, so the next named-only\nutil does not need a manual entry."
    },
    {
      "id": "9.16.1-wrapped-tooltips-fit-their-text",
      "version": "9.16.1",
      "title": "Wrapped tooltips fit their text",
      "date": "2026-10-14",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-654/tooltip-leaves-empty-space-on-the-right-when-its-text-wraps",
      "tags": [
        "layout"
      ],
      "components": [
        "Spds::Feedback::Tooltip"
      ],
      "capabilities": [],
      "services": [],
      "body": "A tooltip whose text wraps at its `240px` cap used to stay `240px` wide, leaving a band of\nempty space between the longest line and the right edge. Tooltips now narrow to their longest\nrendered line, so the right padding matches the left. Single-line tooltips and the `240px` cap\nare unchanged, and there is nothing to adopt — the fix applies to `Spds::Feedback::Tooltip`,\nthe `{{spds-tooltip}}` modifier, and the `spds/tooltip` service alike.\n\n## Why CSS alone cannot do this\n\n`width: max-content`, `fit-content`, and `inline-block` all size a box from its _unwrapped_\ntext, clamped by `max-width`. Once the text wraps, the box keeps the clamped width; CSS has no\nvalue for \"the width of the longest line after wrapping\". Measuring the rendered lines is the\nonly way to get it."
    },
    {
      "id": "9.16.0-introduce-divider-component",
      "version": "9.16.0",
      "title": "Introduce divider component",
      "date": "2026-10-12",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-584/introduce-divider-component",
      "tags": [
        "DS Component Creation",
        "a11y"
      ],
      "components": [
        "Spds::Container::Divider"
      ],
      "capabilities": [],
      "services": [],
      "body": "`Spds::Container::Divider` is a 1px line that separates content into groups, sections, or options.\nIt replaces the one-off divider elements apps have been styling by hand.\n\n```hbs\n<Spds::Container::Divider />\n\n<Spds::Layout::Flex::Row @gap=\"8px\">\n  <span>Left</span>\n  <Spds::Container::Divider @orientation=\"vertical\" />\n  <span>Right</span>\n</Spds::Layout::Flex::Row>\n```\n\nArguments:\n\n* `@orientation` (`horizontal` | `vertical`, default `horizontal`): a horizontal divider fills the\n  width of its parent; a vertical one stretches to the height of its flex parent, so give it an\n  explicit height when the parent is not a flex container.\n* `@color` (`primary` | `secondary` | `inverse` | `brand`, default `primary`): backed by the\n  `--token-color-border-divider-*` tokens. Use `inverse` and `brand` on dark or brand-colored\n  surfaces.\n\nThe divider renders as a `role=\"separator\"` with a matching `aria-orientation`. When a line is\npurely visual, pass `aria-hidden=\"true\"` so screen readers skip it.\n\nDividers are a style decision, not a border: use them between standalone elements, and keep using\nborders for the edges of a component."
    },
    {
      "id": "9.15.0-collapsible-opensto",
      "version": "9.15.0",
      "title": "Collapsible @opensTo",
      "date": "2026-10-12",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-605/introduce-expandable-flyoutmodal",
      "tags": [
        "panels",
        "keyboard navigation"
      ],
      "components": [
        "Spds::Panel::Collapsible"
      ],
      "capabilities": [],
      "services": [],
      "body": "`Spds::Panel::Collapsible` gains `@opensTo`, the direction the panel grows as it opens: `left` (the\ndefault, unchanged), `right`, `top`, or `bottom`. The separating border moves to the growing edge, and\nthe content is pinned to that edge so it slides in rather than being uncovered. `top` and `bottom`\nanimate `height` instead of `width`, using `@size` as the height; override it with `--panel-height`.\n\n```hbs\n<Spds::Panel::Collapsible @ariaLabel=\"Menu\" @opensTo=\"right\" @onClose={{this.closeMenu}}>\n  ...\n</Spds::Panel::Collapsible>\n```\n\nA panel opening to the right suits a menu on the left of a panel's content. Escape inside a\n`Collapsible` nested in a non-modal flyout closes only the `Collapsible`."
    },
    {
      "id": "9.15.0-expand-and-menu-buttons",
      "version": "9.15.0",
      "title": "Expand and Menu buttons",
      "date": "2026-10-12",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-605/introduce-expandable-flyoutmodal",
      "tags": [
        "a11y"
      ],
      "components": [
        "Spds::Action::Button::Expand",
        "Spds::Action::Button::Menu"
      ],
      "capabilities": [],
      "services": [],
      "body": "Two icon buttons, built like `Spds::Action::Button::Close`.\n\n`Spds::Action::Button::Expand` switches a view between a collapsed panel and full screen. `@expanded`\npicks the icon (arrows pointing out to expand, pointing in to collapse) and the accessible name\n(\"Expand to full screen\" / \"Collapse to panel\"). The name carries the state, so it sets no\n`aria-expanded`.\n\n```hbs\n<Spds::Action::Button::Expand @expanded={{this.expanded}} @toggle={{this.toggleExpanded}} />\n```\n\n`Spds::Action::Button::Menu` is a hamburger button for a menu the consumer renders. `@expanded` sets\n`aria-expanded` and `@controls` points `aria-controls` at the menu's id; the accessible name defaults\nto \"Menu\" and stays the same in both states.\n\n```hbs\n<Spds::Action::Button::Menu\n  @controls={{this.menuId}}\n  @expanded={{this.menuOpen}}\n  @toggle={{this.toggleMenu}}\n/>\n```\n\nBoth pair with the panel header's `:leading-actions` and `:additional-actions` blocks. New\n`arrows-expand`, `arrows-collapse`, and `hamburger` icons ship with them."
    },
    {
      "id": "9.15.0-panel-header-action-blocks",
      "version": "9.15.0",
      "title": "Panel header action blocks",
      "date": "2026-10-12",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-605/introduce-expandable-flyoutmodal",
      "tags": [],
      "components": [
        "Spds::Layout::Panel",
        "Spds::Modal::Flyout",
        "Spds::Panel::Collapsible"
      ],
      "capabilities": [],
      "services": [],
      "body": "The shared panel header that `Spds::Modal::Flyout` and `Spds::Panel::Collapsible` render gains two\noptional named blocks:\n\n- `:leading-actions` renders before the title, for a control such as a menu button.\n- `:additional-actions` renders before the close button, matching the block of the same name on\n  `Spds::Modal::FullScreen`'s header.\n\n```hbs\n<Spds::Modal::Flyout @onClose={{this.close}} as |f|>\n  <f.Header>\n    <:leading-actions>{{! a menu button }}</:leading-actions>\n    <:title>Sidekick</:title>\n    <:additional-actions>{{! an expand button }}</:additional-actions>\n  </f.Header>\n</Spds::Modal::Flyout>\n```\n\nEach block carries the always-on `spds-layout-panel-header-leading-actions` /\n`spds-layout-panel-header-additional-actions` class and test selector, plus the owner's\n(`spds-modal-flyout-header-leading-actions`, `data-test-spds-panel-collapsible-header-additional-actions`,\nand so on). A header without either block renders exactly as before."
    },
    {
      "id": "9.15.0-spds-modal-expandable",
      "version": "9.15.0",
      "title": "Spds::Modal::Expandable",
      "date": "2026-10-12",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-605/introduce-expandable-flyoutmodal",
      "tags": [
        "a11y"
      ],
      "components": [
        "Spds::Modal::Expandable",
        "Spds::Panel::DockableFlyout"
      ],
      "capabilities": [],
      "services": [],
      "body": "A panel that expands to full screen and collapses back. Collapsed it is a\n`Spds::Panel::DockableFlyout`, so `@docked` picks an overlay flyout or an in-flow panel; expanded it\nis a `Spds::Modal::FullScreen`. Both views stay mounted across a switch, and the consumer sees one\n`@onOpen` and one `@onClose` for the whole component.\n\n```hbs\n<Spds::Modal::Expandable @docked={{this.docked}} @onClose={{this.close}} as |x|>\n  <x.Collapsed as |c|>\n    <c.Header>\n      <:title>Assistant</:title>\n      <:additional-actions><x.Toggle /></:additional-actions>\n    </c.Header>\n    <c.Body>...</c.Body>\n  </x.Collapsed>\n\n  <x.Expanded as |e|>\n    <e.Header>\n      <:title>Assistant</:title>\n      <:additional-actions><x.Toggle /></:additional-actions>\n    </e.Header>\n    <e.Body @fill={{true}}>...</e.Body>\n  </x.Expanded>\n</Spds::Modal::Expandable>\n```\n\n`x.Toggle` is an `Spds::Action::Button::Expand` wired to the current mode; focus moves onto the\nincoming view's toggle after each switch. The yield also carries `isExpanded`, `expand`, `collapse`,\nand `toggle`. Escape in the expanded view closes the whole component, like its close button, and a\n`@docked` change while expanded takes effect on collapse.\n\n`Spds::Panel::DockableFlyout` now exposes `isClosing`, and both wrappers return focus on the final\nclose only when it was lost, so a parent moving focus into another shell keeps it there."
    },
    {
      "id": "9.15.0-spds-panel-dockableflyout",
      "version": "9.15.0",
      "title": "Spds::Panel::DockableFlyout",
      "date": "2026-10-12",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-605/introduce-expandable-flyoutmodal",
      "tags": [
        "a11y"
      ],
      "components": [
        "Spds::Panel::DockableFlyout"
      ],
      "capabilities": [],
      "services": [],
      "body": "A side panel that docks into document flow or floats over the page. Undocked it is a\n`Spds::Modal::Flyout`; docked it is a `Spds::Panel::Collapsible` that pushes the content beside it.\nFlipping `@docked` while open hands off between the two without a visible close: `@onClose` fires\nonly for the final close, and `@onOpen` / `@onShow` only for the first open and re-opens.\n\n```hbs\n<div class=\"layout\">\n  <main>...</main>\n  <Spds::Panel::DockableFlyout @docked={{this.docked}} @onClose={{this.close}} as |d|>\n    <d.Header>\n      <:title>Details</:title>\n    </d.Header>\n    <d.Body>...</d.Body>\n  </Spds::Panel::DockableFlyout>\n</div>\n```\n\nThe yielded hash carries the active shell's `Header`, `Body`, `Footer`, `beforeClose`, and `close`,\nplus `docked`. Each shell renders its own copy of the block, so keep state that must survive a dock\nin the consumer. `@modal` and `@closeOnClickOutside` apply to the flyout only. Focus moves into the\nshell taking over, and the final close returns it to the original trigger.\n\nBoth shells stay mounted after the first dock or undock, so each gets its own id: `@id` suffixed\nwith `-overlay` for the flyout and `-docked` for the panel. Pass `@id` rather than an `id`\nattribute, since attributes land on both shells."
    },
    {
      "id": "9.14.2-file-upload-dropzones-no-longer-flicker-while-dragging",
      "version": "9.14.2",
      "title": "File-upload dropzones no longer flicker while dragging",
      "date": "2026-10-05",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DOC-524",
      "tags": [],
      "components": [
        "Shared::DropZone"
      ],
      "capabilities": [],
      "services": [],
      "body": "Dragging a file across a `Shared::DropZone` no longer toggles the drop overlay on and off as the pointer crosses elements inside the zone. That flicker was most visible on Windows, and it could drop the file outside the zone even though the cursor was still over it.\n\nChromium fires `dragleave` when the pointer moves between children of the dropzone. Those events used to bubble to `ember-file-upload`'s `FileDropzone`, which treated each one as leaving the zone and flipped `dropzone.active`. The overlay now ignores a `dragleave` whose target and `relatedTarget` are both still inside the dropzone root, so the active state stays on until the pointer actually leaves."
    },
    {
      "id": "9.14.1-keep-menus-and-modals-fixed-regardless-of-css-order",
      "version": "9.14.1",
      "title": "Keep menus and modals fixed regardless of CSS order",
      "date": "2026-10-01",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-541/fix-metadata-for-layout-components",
      "tags": [
        "positioning"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "Menus, tooltips, toast messages, and the standard modal declared `position: fixed` in their own\nstylesheets, at the same specificity as `Spds::Core::Container`'s base `position: relative`. The\naddon build does not emit CSS in a stable order, so which rule won could change from one release\nto the next. With the wrong order, an open menu fell back to absolute positioning and drifted away\nfrom its trigger inside modals and on scrolled pages.\n\nThese surfaces now render their root with `@fixed={{true}}`, as the flyout and full-screen modals\nalready did. Container's `fixed` class outranks its base rule whatever order the CSS lands in. The\nflyout's `transition: .3s all` is now `transition: right .3s`, the only property it animates, so it\nno longer depends on which `transition-behavior` wins either.\n\nNothing changes for consumers: this locks in the behavior 9.13.1 shipped. Making the CSS order\nitself deterministic is tracked in\n[DES-666](https://linear.app/simplepractice/issue/DES-666/addon-css-order-is-nondeterministic-so-same-specificity-rules-resolve)."
    },
    {
      "id": "9.14.0-ds-modals-and-the-collapsible-panel-can-be-re-opened",
      "version": "9.14.0",
      "title": "DS modals and the collapsible panel can be re-opened",
      "date": "2026-09-30",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-606",
      "tags": [],
      "components": [
        "Spds::Core::Modal",
        "Spds::Modal::Container::Global",
        "Spds::Panel::Collapsible"
      ],
      "capabilities": [
        "Dismissible"
      ],
      "services": [
        "spds/modal"
      ],
      "body": "A component built on `Dismissible` used to be single-use: once it closed, the only way to show it\nagain was to unmount it and mount a new one. It can now be shown again in place with `reopen()`,\nwhich runs the same open lifecycle as the first mount — `@onOpen`, the entry animation, focus, and\n`@onShow` — and fires `@onClose` again on the next close.\n\n## What's new\n\n- **`reopen()`** on any `Dismissible` component. It is a no-op while the component is open or still\n  opening. Called during an exit animation, it waits for that close to finish and report, then opens,\n  so `@onClose` always fires once per cycle. Reach the instance through `@registerComponent`.\n- **`isOpen`**, a tracked flag that is true from the moment the component has finished showing until\n  its close is reported. A component closed before it finished showing never reads `true`.\n- **`Spds::Panel::Collapsible`** supports `reopen()` too. A re-opened panel is interactive again,\n  focus returns to whatever re-opened it rather than the original trigger, and the width transitions\n  up from zero as it does on first render.\n\n## Modals release their hold on close, not on unmount\n\n`Spds::Core::Modal` now leaves the open-modal stack and releases its body scroll lock when it closes,\ninstead of waiting to be destroyed. A modal kept mounted after closing no longer holds the page's\nscroll lock or counts as the topmost modal. A re-open during the exit animation keeps the lock\nthroughout, so the page does not jump.\n\n## `Spds::Modal::Container::Global` animates programmatic closes\n\nClosing a global modal programmatically (`closeModal`) now runs the modal's exit animation before it\nis removed, as the close button always did. Two fixes come with it:\n\n- `@onBeforeClose` runs once per close. It previously ran twice on some routes, so a guard that\n  flipped state on its first call could strand the modal open.\n- `closeModal()` with no id closes the topmost modal, as documented, rather than the first one.\n\n## For consuming apps\n\nNothing to adopt; mounting and unmounting to show and hide keeps working as before.\n\nOne service change: `spds/modal`'s `registerOpenModal` and `unregisterOpenModal` now take the modal\ncomponent instance rather than its element id, and assert when given a string. They are called by\n`Spds::Core::Modal` itself; code that called them directly should use `openModalFor(id)` to look up\nan open modal by id instead."
    },
    {
      "id": "9.13.1-migrate-ember-simplepractice-to-pnpm",
      "version": "9.13.1",
      "title": "Migrate ember-simplepractice to pnpm",
      "date": "2026-09-30",
      "type": "cleanup",
      "issue": "https://linear.app/simplepractice/issue/ENG-819/phase-2-migrate-ember-simplepractice-and-all-nested-packages-to-pnpm",
      "tags": [
        "DS Maintenance",
        "internal",
        "tooling"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "Beta cut of ENG-817 Phase 2: this monorepo now installs, builds, and publishes with\npnpm. Consumer-facing surface is unchanged — the addon tarball still declares\n`@simplepractice/design-system-tokens` as `~<version>` (pnpm rewrites `workspace:~` at\npack time) and the new `src/assets/icons` entry in the tarball ships the icon set the\naddon already read from `src`. Beta lets each Yarn Classic consumer confirm the\ntarball still installs and boots under yarn 1 before ENG-820 flips `client-portal`.\n\nAlso republished as part of this beta: `@simplepractice/svg-lint@0.0.0-eng819.0` fixes\nthe `yarn svgo` shell-out in its bins that broke as soon as a consumer set\n`packageManager: pnpm@…`. It now resolves `svgo` from its own dependency graph via\n`require.resolve('svgo/package.json', { paths: [__dirname] })` and invokes it through\n`process.execPath`, making the bin package-manager-agnostic."
    },
    {
      "id": "9.13.0-collapsible-panel",
      "version": "9.13.0",
      "title": "Collapsible panel",
      "date": "2026-09-29",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-632/introduce-collapsible-panel-component",
      "tags": [
        "a11y",
        "focus management"
      ],
      "components": [],
      "capabilities": [
        "Dismissible"
      ],
      "services": [],
      "body": "`Spds::Panel::Collapsible` is a side panel that sits in document flow and pushes the content beside\nit, rather than overlaying it. It wears the same header / body / footer chrome as\n`Spds::Modal::Flyout`, but it is not a dialog: there is no backdrop, the rest of the page stays\ninteractive, and clicking outside leaves the panel open.\n\nReach for it when the panel is part of the work rather than an interruption — filters beside a list,\na detail pane beside a table, anything a user reads and edits while still using the page. Reach for\n`Spds::Modal::Flyout` when the panel _is_ the task and the page behind it should wait.\n\n```hbs\n{{#if this.filtersOpen}}\n  <Spds::Panel::Collapsible @onClose={{this.closeFilters}} @size=\"small\" as |P|>\n    <P.Header>\n      <:title>Filters</:title>\n    </P.Header>\n    <P.Body>{{! ... }}</P.Body>\n  </Spds::Panel::Collapsible>\n{{/if}}\n```\n\nLike every dismissible, it is born open and does not reopen in place — render it behind an `{{#if}}`\nand flip that flag from `@onClose`.\n\n### Placement and height\n\nThe panel is an `aside` in normal flow, so its height comes from the parent's layout rather than the\nviewport. In a flex or grid parent it stretches to the full row or track height, which is the usual\narrangement. In a block parent it grows to fit its own content instead, so give that parent a\nresolved height and the panel `height: 100%` if it needs to fill.\n\nOpening is a change in the room the panel takes from its siblings, so it animates `width` from zero\nrather than sliding in over the page. The left border that separates it from the content beside it is\ndrawn inside that width rather than added to it, so `@size` stays the panel's true footprint.\n\n### Focus and Escape\n\nThe panel takes focus when it opens and hands it back to whatever had it as the close begins. It does\nnot trap focus — tabbing past its last control continues into the rest of the page, which is the\npoint of a panel that leaves the page live. Escape dismisses it through the same guarded path as the\nclose button, so `@onBeforeClose` gets its say; pass `@closeOnEscape={{false}}` on a panel holding\nunsaved input that does not already guard dismissal.\n\n### Shared chrome\n\nThe chrome both panels render now lives in `Spds::Layout::Panel`, which each of them composes and\nre-yields. **No call-site change is needed.** `Spds::Modal::Flyout` yields the same `Header`, `Body`,\nand `Footer`, and every chrome node still carries its `spds-modal-flyout-*` class and\n`data-test-spds-modal-flyout-*` selector, so existing tests and consumer CSS keep matching.\n\nThose nodes now also carry an always-on `spds-layout-panel-*` class, and that is where the chrome\nstyles live. Consumer CSS should keep targeting the owner classes; the layout ones are SPDS's.\n\n### Accessible naming on both panels\n\nThe flyout previously bound `aria-labelledby` to its header title unconditionally, which pointed\nevery header-less flyout at an id that does not exist. Both panels now resolve their name from what\nis actually rendered: the header title when the `Header` block is present, `@ariaLabel` when it is\nnot, and neither attribute — plus a development warning — when there is no name to be had. A name\nyou supply yourself wins outright, whether that is an `aria-labelledby` or an `aria-label` passed\nthrough `...attributes`; neither is overwritten, and neither counts as missing.\n\nThe header title is also a real `Spds::Typography::Heading::Medium` now, with the description a\n`Spds::Typography::Body::Small`. Text styles are unchanged. `@headingLevel` decouples the semantic\nlevel from that constant visual size: the flyout stays `h1`, and the collapsible panel uses `h2`,\nsince a panel beside page content must not compete with the page heading."
    },
    {
      "id": "9.12.1-a-drag-out-of-a-flyout-or-menu-no-longer-dismisses-it",
      "version": "9.12.1",
      "title": "A drag out of a flyout or menu no longer dismisses it",
      "date": "2026-09-28",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-635",
      "tags": [],
      "components": [
        "Spds::Core::Modal",
        "Spds::Modal::Flyout"
      ],
      "capabilities": [],
      "services": [
        "spds/menu"
      ],
      "body": "Selecting text inside a modal flyout and releasing the mouse outside it used to close the flyout\nmid-edit, discarding whatever was being typed. The same gesture in a menu's search box dropped the\nresults while leaving the query in the input, so it read as a search that found nothing.\n\nBoth surfaces now decide dismissal from where the gesture began, not only from where the browser\nreported the click.\n\n## Why a drag looked like a click outside\n\nWhen `mousedown` and `mouseup` land on different nodes, the browser fires `click` on their nearest\ncommon inclusive ancestor rather than on either target. For a press inside a flyout released\nanywhere outside it, that ancestor is the `<dialog>` itself — which is also exactly what a genuine\nbackdrop click targets, so `evt.target === baseElement` could not tell them apart. For a menu the\nancestor sits above `baseElement`, so both branches of the containment test failed.\n\n## What changed\n\n`Spds::Core::Modal` tracks whether the gesture both began and ended on the backdrop, and dismisses\nonly then. That also settles the mirror case — press on the backdrop, drag into the panel, release\ninside — which used to dismiss and now does not, matching how the browser light-dismisses a native\n`popover=\"auto\"`.\n\n`spds/menu` records the composed path of each press while the nodes it ran through are still\nmounted, and treats a click as inside when either the click or the gesture behind it started inside\nthe boundary. The check is additive, so a click with no recorded press — keyboard activation, a\nprogrammatic dispatch — is judged exactly as before. The existing `dismissSelector` escape hatch is\nuntouched: pressing and releasing on a label still dismisses.\n\nNothing about either public API changes. No new arguments, no renames, no defaults moved, and every\ndismissal still enters through the `Dismissible` capability's `beforeClose`, so `@onBeforeClose` and\nthe existing close lifecycle behave as they did. A flyout that is not `@modal` never had a\nclick-outside listener and is unaffected.\n\n## For consuming apps\n\nNothing to adopt — the fix arrives with the version bump. Focus and text selection are unaffected:\na flyout that survives a drag keeps the focused input and its selection range, so the edit in\nprogress is still there.\n\n## If you test this behavior\n\n`@ember/test-helpers` `click()` fires `mousedown`, `mouseup` and `click` at a single element, so\nexisting tests that dismiss by clicking outside keep passing unchanged. A test for the drag itself\nhas to dispatch the events separately with `triggerEvent`, since the point is that they land on\ndifferent targets. For the same reason the guard is keyed on mouse events rather than pointer\nevents, which `click()` does not fire at all."
    },
    {
      "id": "9.12.0-named-app-reexports-for-star-utils",
      "version": "9.12.0",
      "title": "Named app reexports for star utils",
      "date": "2026-09-22",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/CAL-835/update-sharedtypeahead-to-support-destination-argument",
      "tags": [
        "DS Maintenance"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "App-tree reexports for `deprecation-capture`, `spds/capabilities/helpers`, and\n`spds/metadata/modal-docs` are now `export *`, matching the named exports those\nmodules actually publish.\n\nConsuming apps were patching `dist/_app_` wrappers that only reexported\n`default`, so `import { compose }` / `getDeprecationCaptureCallback` / the\nmodal-docs constants from the app tree resolved as `undefined`. Those modules\nare on the existing `starUtils` allowlist in `rollup.config.mjs`; no consumer\npatch is required after this beta."
    },
    {
      "id": "9.12.0-sharedtypeahead-destination-argument",
      "version": "9.12.0",
      "title": "SharedTypeahead destination argument",
      "date": "2026-09-22",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/CAL-835/update-sharedtypeahead-to-support-destination-argument",
      "tags": [
        "typeahead",
        "overlay"
      ],
      "components": [
        "SharedTypeahead"
      ],
      "capabilities": [],
      "services": [],
      "body": "`SharedTypeahead` accepts `@destination` — the `id` of a DOM node that should host the open menu\ninstead of rendering it next to the trigger.\n\nWhen `@destination` is set, the menu is portaled into that node, repositioned against the trigger\n(including flip and max-height), and keeps keyboard focus and click-outside behavior working across\nthe portal. Pass `@destinationClass` to add classes on the portaled wrapper. Omit `@destination` to\nkeep the previous in-place menu."
    },
    {
      "id": "9.11.0-introduce-spds-core-capabilities",
      "version": "9.11.0",
      "title": "Introduce SPDS core capabilities",
      "date": "2026-09-14",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-628/introduce-spds-core-capabilities",
      "tags": [
        "a11y",
        "architecture",
        "DS Maintenance",
        "internal"
      ],
      "components": [
        "Spds::Core::Modal",
        "Spds::Core::Popover",
        "Spds::Modal::Flyout",
        "Spds::Feedback::AlertBanner::Message",
        "Spds::Feedback::FeatureBanner",
        "Spds::Container::Accordion",
        "Spds::Indicator::LoadingOverlay",
        "Spds::Indicator::Skeleton"
      ],
      "capabilities": [
        "Animated",
        "Dismissible"
      ],
      "services": [
        "BodyScrollManager"
      ],
      "body": "Two behaviors were duplicated across SPDS: the `@animated` argument and its waiting, reimplemented in twenty-one components, and the open/close lifecycle, hand-rolled separately by `Spds::Core::Modal` and the two feedback banners. Neither could be solved by a base class, because the components that share them have nothing in common but `Spds::Core::Base`.\n\n**Core capabilities** are the answer: composable class factories under `core/capability/` that add behavior to a component without changing what it extends. They exist to keep `Spds::Core::Base` from accreting behavior that only some components need.\n\n### Applying a capability\n\nA component names the capabilities it wants and keeps the base it already has:\n\n```js\nimport { Dismissible } from '../core/capability/dismissible.gjs';\nimport { compose } from '../../../utils/spds/capabilities/helpers';\n\nexport default class SpdsFeedbackFeatureBanner extends compose(Super, Dismissible) {}\n```\n\n`compose` applies capabilities left to right and skips any already present in the chain, so naming `Dismissible` alone is enough — it composes `Animated` for itself, and asking for both explicitly still applies each once. Metadata composes through the chain the same way inheritance does, so a capability's arguments are documented on every component that adopts it.\n\n### The two capabilities\n\n- **`Animated`** owns the `@animated` argument, the `animated` class contribution, `animationDuration`, and `awaitAnimation()`. `@animated` stays true under test so class assertions and Percy snapshots keep working; it is `awaitAnimation` that declines to spend the duration.\n- **`Dismissible`** owns the open/close lifecycle and composes `Animated`. On the way in, a component is born open, fires `@onOpen`, hands off to `showElement` to display itself, settles its opening test waiter, then fires `@onShow` — so a consumer that measures or moves focus on `@onShow` gets an element genuinely on screen. On the way out, a dismissal enters through `beforeClose`, which consults `@onBeforeClose` and continues only on a truthy answer, then drops `isVisible` so the stylesheet can play its exit transition, waits that transition out, and hands off to `dismissElement`. Subclasses extend it through `showElement`, `beginDismiss`, and `dismissElement` rather than by rewriting the sequence.\n\nBoth entry points are now latched. A dismissal arriving while an earlier one is still waiting on `@onBeforeClose`, or while the exit transition is playing, is dropped rather than queued — previously a repeated dismissal could raise a second discard prompt behind the first, or fire `@onClose` twice. A banner dismissed twice also no longer takes the bottom of the stack with it: the second dismissal missed the stack and removed the last banner instead, reporting that consumer's close.\n\n### Deliberate behavior changes\n\n- **Non-modal dialogs close on Escape.** The browser dismisses a modal dialog for you but leaves a non-modal one alone, so `Spds::Modal::Flyout` handles the key itself when it is not modal. `@closeOnEscape={{false}}` opts out, and a non-modal flyout holding unsaved input should use it; it does nothing on a modal one, which guards Escape through `@onBeforeClose` instead. An Escape already claimed by something nested inside the flyout closes only that, so a dropdown does not take its container with it.\n- **The banners gained a test waiter.** Tests that previously observed a banner mid-close now settle past it.\n- **`@onOpen` is ordered against `@onShow`.** `Spds::Core::Modal` previously fired `@onOpen` alongside a show it did not await, leaving the two racing. `@onOpen` now fires as the open begins and `@onShow` once the dialog is on screen.\n- **Modals carry an `animated` class** they did not before, inherited from `Animated`. No modal stylesheet has a rule for it.\n\n`Spds::Feedback::AlertBanner::Message` and `Spds::Feedback::FeatureBanner` keep their `open` class alongside the inherited `is-visible` for one major, since consumer stylesheets target it. Both resolve to the same state.\n\n### Body scroll locking\n\n`BodyScrollManager` now tracks lock claims by owner. The lock is a single `overflow` value on `body` and cannot be taken twice, so without bookkeeping whoever released last won outright — closing the top of two stacked modals scrolled the page behind the one still open. The page is now restored only once the last claim is gone. Releasing an owner that never claimed is ignored, so callers can release unconditionally on teardown.\n\n### Impact\n\nTwenty-one components dropped their own `@animated` implementation, `Spds::Core::Modal` and both feedback banners dropped their duplicated lifecycles, and the dead `@beforeClose` argument was removed from the shared footer CTA. Behavior for existing consumers is unchanged apart from the deliberate changes called out above. The win is that the next dismissible component — the drawer, the dockable flyout — adopts the lifecycle instead of re-deriving it."
    },
    {
      "id": "9.10.1-sanitize-html-content",
      "version": "9.10.1",
      "title": "Sanitize HTML content",
      "date": "2026-09-08",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-607/sanitize-ds-html-content",
      "tags": [
        "security",
        "xss",
        "helpers"
      ],
      "components": [
        "Spds::Feedback::Tooltip",
        "Spds::Core::Container"
      ],
      "capabilities": [],
      "services": [],
      "body": "`Spds::Feedback::Tooltip` and `Spds::Core::Container` sanitize their `@content` string before\nrendering it, and the global modal container does the same for `bodyText`. Those three surfaces\nmarked consumer-supplied strings as trusted HTML with no filtering, so any user-controlled value\nreaching them — a client name, an API-sourced label — was a stored-XSS vector.\n\nNothing changes in a component's API and no consumer has to do anything to get the fix. The\n`:title` and `:content` named blocks and `{{yield}}` are untouched: they render developer-authored\ntemplate content rather than runtime strings.\n\n## What survives\n\nTwo policies, both allowlists — an element or attribute has to be named to get through, so event\nhandlers, `style`, `script`, `iframe`, `svg`, and every form element are gone by construction.\n\n**Tooltips** get the strict policy: inline formatting only (`b`, `br`, `em`, `i`, `s`, `small`,\n`span`, `strong`, `sub`, `sup`, `u`, `wbr`) and **no attributes at all**. Anything else is reduced\nto its text, links included, matching the component's existing contract that tooltips cannot\ncontain interactive content. Use the `:content` block for anything richer.\n\n**Containers and modals** get the rich policy: the strict set plus block text structure, lists,\ntables, `a`, and `img`. Attributes are allowlisted per tag, and `a[href]` / `img[src]` are limited\nto `http`, `https`, `mailto`, `tel`, relative URLs, and — for images only — raster data URIs.\n\n### Attributes are dropped unless named, `data-*` included\n\nOnly `title`, `lang`, and `dir` survive globally, plus `href`/`target`/`rel` on `a` and\n`src`/`alt`/`width`/`height` on `img`. **Everything else is removed — `class`, `id`, `style`, and\nevery `data-*` attribute.**\n\n`data-*` is worth calling out because it is easy to assume it is inert enough to keep. It is not\nallowlisted, and that is deliberate: a `data-*` attribute in a content string is\nattacker-controllable, so app code that reads one from rendered content would be trusting user\ninput.\n\nThe practical consequence is that **a marker embedded in a content string cannot be used as a DOM\nsentinel**. Beta testing caught exactly this — an app rendered\n`<span data-my-marker></span>` into an alert-banner body and deduped with\n`document.querySelector('[data-my-marker]')`. The attribute was stripped, the guard never fired,\nand banners stacked up on every navigation. If you need a hook, use one on the component's own\nelement rather than inside `@content`.\n\n## Links now open in a new tab\n\nUnder the rich policy, **every anchor in a content string gets `target=\"_blank\"` and\n`rel=\"noopener noreferrer\"`**, an existing `target` is overwritten, and this applies to relative\nin-app links such as `/clients/123` as much as to external ones. Nothing renders an anchor through\n`@content` today, so no current behavior changes, but it is a design-system-wide rule worth knowing\nbefore you add the first one. Tooltips are unaffected — the strict policy has no `a`.\n\n## For app-level `htmlSafe` call sites\n\nThe sanitizer ships as a helper with the same call signature as `htmlSafe`, so replacing one is a\none-token swap:\n\n```handlebars\n{{spds-sanitize-html this.userSuppliedString}}\n{{spds-sanitize-html this.userSuppliedString policy=\"strict\"}}\n```\n\nIn a `.gjs` file or a JS getter, import it directly:\n\n```js\nimport { sanitizeHtml } from 'ember-simplepractice/helpers/spds-sanitize-html';\nimport { STRICT } from 'ember-simplepractice/utils/spds/html-verification';\n\nget content() {\n  return sanitizeHtml(this.args.content, STRICT);\n}\n```\n\nThe name is deliberately prefixed so it does not collide with an app's own `sanitize-html` helper."
    },
    {
      "id": "9.10.0-shared-menu-click-outside-service",
      "version": "9.10.0",
      "title": "Shared menu click-outside service",
      "date": "2026-09-03",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-608/reduce-number-of-events-triggered-by-closeonclickoutside-when-menu",
      "tags": [
        "menus",
        "performance"
      ],
      "components": [
        "Spds::Action::Button::Dropdown",
        "Spds::Action::Button::Filter::Multiselect",
        "Spds::Action::Button::Filter::SingleSelect",
        "Spds::Action::Button::Split",
        "Spds::Core::KeyboardNavigable",
        "Spds::Feedback::Tooltip::Container",
        "Spds::Input::Dropdown::List",
        "Spds::Input::Search"
      ],
      "capabilities": [],
      "services": [
        "Menu"
      ],
      "body": "Click-outside dismissal for SPDS menus now runs through a new `spds/menu` service that owns a single\n`document` click listener, replacing the listener that `{{closeOnClickOutside}}` attached per call\nsite.\n\nPreviously every mounted call site was invoked on every click anywhere in the app, and each one\ncalled `event.composedPath()` — an allocation of the full DOM path — before deciding it had nothing\nto do. On a screen with many menus that added up. The shared listener computes the composed path\nonce per click, and returns before touching it at all when nothing is open.\n\nClose handlers no longer run while a menu is closed. The service reads `open` off each registered\nmenu when the click arrives, so a stray click can no longer fire a consumer's `@onClose` (or clear\noption state) on a menu the user never opened.\n\n## For components extending `Spds::Core::KeyboardNavigable`\n\nRegistration is automatic — `setup()` registers the instance and a destructor unregisters it, so\nthere is no template wiring and nothing to remember on open or close. **Remove any\n`{{closeOnClickOutside}}` from such a component**; leaving it in place registers the menu twice and\ncalls `handleClose` twice per outside click. Set the new `dismissSelector` class field when a control\ninside the container should dismiss the menu anyway, the way `Spds::Input::Search` and\n`Spds::Input::Dropdown::List` do for their labels.\n\n## For everything else\n\n`{{closeOnClickOutside handler selector}}` keeps its signature and behavior, so existing call sites\non plain markup and on non-SPDS components need no changes to pick up the shared listener. It now\nregisters an adapter with the service instead of attaching its own listener, and re-runs update the\nhandler and selector in place rather than re-registering. This also fixes a latent bug where the\nmodifier registered a new destructor on every re-run.\n\n## Tooltip update race\n\n`Spds::Feedback::Tooltip::Container` no longer throws when an update arrives for a tooltip that has\nalready been unregistered — it is treated as a no-op.\n\n`alertManager.broadcast` awaits `waitForBroadcastChannel` before running its handler, while the\n`clear` path behind `tooltip.unregister` does not, so an update issued just before teardown could\nland after the entry was gone and throw `Object.assign(undefined, ...)` as an uncaught error. That\nfailed whichever test happened to be running. The race predates this release; the change in listener\ntiming above is what started losing it.\n\n## A note on `fastboot` in services\n\n`spds/menu` resolves the FastBoot check **once in its constructor** rather than injecting it or\nlooking it up on demand, because both alternatives throw — and the reason is worth knowing before\nadding another service here.\n\n`@service fastboot` cannot be used: a service, unlike a component or modifier, has its injections\nvalidated on instantiation, so it raises `Attempting to inject an unknown injection` in any build\nwithout `ember-cli-fastboot` registered. Looking it up lazily instead fails the other way round: the\n`unregisterMenu` destructor can run after the owner has been torn down, and `lookup` is illegal by\nthen — `Cannot call .lookup('service:fastboot') after the owner has been destroyed`. The constructor\nis the one point that is always inside the owner's lifetime."
    },
    {
      "id": "9.9.1-single-select-filter-keeps-aria-selected-when-options-are-replaced",
      "version": "9.9.1",
      "title": "Single-select filter keeps aria-selected when options are replaced",
      "date": "2026-08-31",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-601/spds-filtersingleselect-loses-its-aria-selected-option-when-options-is",
      "tags": [
        "filters",
        "menus",
        "a11y"
      ],
      "components": [
        "Spds::Action::Button::Filter::SingleSelect"
      ],
      "capabilities": [],
      "services": [],
      "body": "`Spds::Action::Button::Filter::SingleSelect` now derives each option's `aria-selected` state from\nthe current value when it renders, instead of stamping the attribute onto the DOM once.\n\nThat stamp was lost whenever `@options` was replaced with an equivalent array — for example after\nan async re-fetch that recreates the option objects. The trigger label stayed correct, so the menu\nread as \"nothing applied\" while the filter was in fact applied. New option elements now render with\nthe right `aria-selected` marker because it is bound to the selected value."
    },
    {
      "id": "9.9.0-filter-buttons-can-control-their-in-menu-search",
      "version": "9.9.0",
      "title": "Filter buttons can control their in-menu search",
      "date": "2026-08-25",
      "type": "fix",
      "tags": [
        "filters",
        "menus"
      ],
      "components": [
        "Spds::Action::Button::Filter::Base",
        "Spds::Action::Button::Filter::SingleSelect"
      ],
      "capabilities": [],
      "services": [],
      "body": "`Spds::Action::Button::Filter::Base` and `Spds::Action::Button::Filter::SingleSelect` now accept\n`@searchable`, `@searchPlaceholder`, `@searchThreshold`, and `@noResultsText`, and forward them to\nthe menu.\n\nTheir menu is built on `Spds::Menu::Filterable`, which adds an in-menu search field on its own once\nthe item count reaches `@searchThreshold` (15 by default). Neither component accepted any of those\narguments, so the search field appeared on any filter with 15 or more items and there was no way to\nturn it off, rename its placeholder, retune the threshold, or set the no-results text. Filters that\nare close to the threshold may see a search field appear or disappear depending on the item count;\npass `@searchable={{false}}` to opt out entirely.\n\nThe naming matches the other components that already expose these — `Spds::Action::Button::Dropdown`,\n`Spds::Action::Button::Filter::Multiselect`, and `Spds::Input::Dropdown::List` — so the search\narguments stay unprefixed even on hosts whose other menu pass-throughs use the `menu` prefix\n(`@menuWidth`, `@menuPlacement`).\n\n`Spds::Action::Button::Split` is unchanged. Its menu passes no items to `Filterable`, so the\nautomatic search never triggers there."
    },
    {
      "id": "9.9.0-include-buttons-and-boolean-inputs-in-macos-tab-order",
      "version": "9.9.0",
      "title": "Include buttons and boolean inputs in macOS Tab order",
      "date": "2026-08-25",
      "type": "fix",
      "tags": [
        "a11y",
        "keyboard navigation"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "macOS Keyboard navigation is off by default, so Chrome and Safari omit native `<button>`,\ncheckbox, and radio controls from sequential Tab order. SPDS already drew focus rings for these\nelements; they just never received Tab focus on a default Mac.\n\n`Spds::Core::Button` and `Spds::Core::Input` now set an explicit `tabindex` so those controls are\nincluded without asking users to change an OS setting, and without replacing native elements.\n\n- Buttons (every variant that extends `Spds::Core::Button`) default to `tabindex=\"0\"`. Pass\n  `tabindex=\"-1\"` to opt out (the search clear button already does). Disabled buttons using a\n  custom `@tag` are removed from Tab order, since `disabled` only does that for a native\n  `<button>`. Route links are unchanged — native anchors stay in Tab order on their own. Menu\n  items opt out so arrow keys (not Tab) move through the list, matching\n  `Spds::Core::KeyboardNavigable`.\n- Checkboxes and toggles default to `tabindex=\"0\"`. Checkboxes inside menus pass `@tabIndex=\"-1\"`\n  for the same arrow-key pattern.\n- Grouped radios keep a single tab stop: the checked option, or the first option when none are\n  checked. Arrow keys still move within the group. This reads the live checked state rather than a\n  component argument, so it stays correct for uncontrolled groups and for any group whose selection\n  is not fed back through `@checked` or `@radioData`. The stop moves both when a user selects an\n  option and when a controlled `@checked` or `@disabled` re-renders, so programmatic selection —\n  `Spds::Navigation::Tabs` applying `@activeTab`, for instance — does not leave the stop behind on\n  the previously selected option. A group is scoped the way the\n  browser scopes one — a shared group name within a shared form — so reusing a name inside and\n  outside a `<form>` gives two independent groups. It applies however the group is composed —\n  `Spds::Input::Group::RadioButton` (`@radioData`, the `:inputs` block, or the yielded `radio`),\n  `Spds::Action::SegmentedControl`, and `Spds::Navigation::Tabs` alike.\n\nFocus styles are unchanged. This does not affect leftover native `<button>` / radio markup outside\nSPDS."
    },
    {
      "id": "9.9.0-single-select-filter-accepts-a-custom-default-option-label",
      "version": "9.9.0",
      "title": "Single-select filter accepts a custom default option label",
      "date": "2026-08-25",
      "type": "enhancement",
      "tags": [
        "filters",
        "menus"
      ],
      "components": [
        "Spds::Action::Button::Filter::SingleSelect"
      ],
      "capabilities": [],
      "services": [],
      "body": "`Spds::Action::Button::Filter::SingleSelect` builds its default option by pluralizing `@filterFor`, which\nreads correctly for countable nouns (\"All documents\") but not for mass nouns — \"billing\" came out as\n\"All billings\".\n\nConsumers can now pass `@allOptionLabel` to supply that label outright:\n\n```hbs\n<Spds::Action::Button::Filter::SingleSelect\n  @allOptionLabel=\"All billing\"\n  @filterFor=\"billing\"\n  @onSelect={{this.handleSelect}}\n/>\n```\n\nThe label applies to both the default menu item and the trigger's resting text. Without the argument the\ncomponent pluralizes `@filterFor` exactly as before, so existing invocations are unchanged.\n\nPrefer this over registering the noun as uncountable with `ember-inflector`. Those rules are global and\nmatch the last word of a name, splitting on `-`, `_`, `/`, and whitespace — so making \"billing\" uncountable\nalso changes how Ember Data pluralizes a model named `polymorphic/billing`, and silently rewrites its\nrequest URL."
    },
    {
      "id": "9.9.0-single-select-filter-accepts-custom-trigger-content",
      "version": "9.9.0",
      "title": "Single-select filter accepts custom trigger content",
      "date": "2026-08-25",
      "type": "enhancement",
      "tags": [
        "filters",
        "menus"
      ],
      "components": [
        "Spds::Action::Button::Filter::SingleSelect"
      ],
      "capabilities": [],
      "services": [],
      "body": "`Spds::Action::Button::Filter::SingleSelect` derives its trigger label from the selected option's text,\nwhich left no room for consumers that need a badge, a count, or any other markup next to the label. Those\nconsumers hand-rolled the whole filter on `Spds::Action::Button::Filter::Base` instead, and so inherited a\nmenu of `tabindex=\"-1\"` options with no arrow-key engine behind it.\n\nThe component now accepts a `:label` block that replaces the derived label. The filter icon and the caret\nstill render around it, so only the middle of the trigger changes:\n\n```hbs\n<Spds::Action::Button::Filter::SingleSelect @filterFor=\"document\" @onSelect={{this.handleSelect}}>\n  <:label>\n    <Spds::Indicator::Badge::Counter::Notification>{{this.count}}</Spds::Indicator::Badge::Counter::Notification>\n    <span>{{this.label}}</span>\n  </:label>\n  <:menu as |SF|>\n    <SF.item @value=\"drafts\">Drafts</SF.item>\n  </:menu>\n</Spds::Action::Button::Filter::SingleSelect>\n```\n\nEmber does not allow a default block alongside named blocks, so `:label` comes with a matching `:menu`\nblock that yields the same `item` component the default block already yielded. Menu content is now\nresolved from `@options`, then `:menu`, then the default block. Existing invocations are untouched — the\ndefault block and `@options` behave exactly as before."
    },
    {
      "id": "9.9.0-single-select-filter-keeps-up-with-options-that-change",
      "version": "9.9.0",
      "title": "Single-select filter keeps up with options that change",
      "date": "2026-08-25",
      "type": "fix",
      "tags": [
        "filters",
        "menus",
        "keyboard navigation"
      ],
      "components": [
        "Spds::Action::Button::Filter::SingleSelect"
      ],
      "capabilities": [],
      "services": [],
      "body": "`Spds::Action::Button::Filter::SingleSelect` captured its option list once, on the render after mount,\nand never looked again. A filter whose options change afterwards — one that swaps its list when a tab\nchanges, for instance — was left navigating the original set: arrow keys could not reach an option\nadded later and could not select it, while an option that had been removed still took up a stop in the\nrotation.\n\nThe component now reads its options live, like every other menu host.\n\nThe list was frozen to keep the trigger label from reading the menu during render, which Glimmer rejects\nas a backtracking update because the menu registers itself in that same pass. The label no longer needs\nthat read. When menu content comes from `@options` the label is derived from the data, so it also stays\ncurrent as labels themselves change; for block-supplied items, whose text exists only in the DOM, it is\ncaptured when the selection is made.\n\nNo API change — this only affects consumers whose option list changes after the filter mounts."
    },
    {
      "id": "9.9.0-tab-leaves-an-open-menu-instead-of-walking-its-options",
      "version": "9.9.0",
      "title": "Tab leaves an open menu instead of walking its options",
      "date": "2026-08-25",
      "type": "enhancement",
      "tags": [
        "a11y",
        "keyboard navigation"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "Menu-style components now follow the ARIA Authoring Practices Guide\n[Menu and Menubar pattern](https://www.w3.org/WAI/ARIA/apg/patterns/menubar/) for Tab. As the APG\nputs it, because menus are composite widgets, \"Tab and Shift + Tab do not move focus among the\nitems in the menu\" — instead they \"move focus out of the menu or menubar, and close all menus and\nsubmenus.\"\n\n`Spds::Core::KeyboardNavigable` previously treated Tab and Shift+Tab as ArrowDown and ArrowUp, so\nan open menu captured sequential focus and Tab stepped through the options one at a time.\n\nTab is no longer captured. When the menu is open, Tab and Shift+Tab return focus to the trigger,\nclose the menu, and let the browser perform its own sequential focus move from there. Nothing is\nselected on the way out. Arrow keys are unchanged and remain the only way to move among options,\nincluding the wrapping behavior components opt into with `wrapAround`.\n\nReturning focus to the trigger is what makes the browser resume from the right place: menu options\nare `tabindex=\"-1\"`, so they are skipped as Tab targets, but sequential order is still resolved\nrelative to whatever is focused. The menu is also marked `inert` for the rest of the keypress, since\nit is not unmounted until after the browser has acted on the key — without that, Tab could land on\nmenu chrome on its way out, such as an in-menu search field or the multiselect \"Select all\" button.\nComponents built on `Spds::Core::KeyboardNavigable` that have a trigger must override\n`exitToTrigger`, and should register their menu as the `optionSource` so it can be sealed.\n\nEscape now returns focus to the trigger too. It previously left focus on whichever option the arrow\nkeys had moved to, so hiding the menu dropped focus to the body and the keyboard user lost their\nplace in the page. This matches what the APG prescribes for Escape: close the menu and set focus on\nthe element that invoked it.\n\nBoth keys respect a host that refuses to close. `Spds::Input::Search` and\n`Spds::Input::Dropdown::List` keep their menu open when an `onClose` handler returns `false`, and\nfocus now stays inside the widget when that happens rather than being handed to the trigger of a\nmenu that is still showing.\n\n### Every menu now has arrow-key navigation\n\nMenu options are `tabindex=\"-1\"` so arrow keys, not Tab, move through them. That only works if the\ncomponent hosting the menu has an arrow-key engine, and several did not: their menus could be\nopened but not operated from the keyboard. `Spds::Action::Button::Dropdown`,\n`Spds::Action::Button::Split`, and `Spds::Action::Button::Filter::Multiselect` are now built on\n`Spds::Core::KeyboardNavigable` like the rest, so all of them support the same interaction:\nArrowUp / ArrowDown to open and move (wrapping at the ends), Enter to activate the focused option,\nEscape to close, and Tab to leave.\n\n`Spds::Action::Button::Split` is the one host whose element holds a control that is not part of its\nmenu, so its main action button keeps its own Enter and Space. Components in that shape should\noverride the new `ownsKeyEvent(evt)` hook, or the engine will treat Enter as a menu-open key and\nsuppress the control's activation. That override should still hand Escape and Tab to the engine\nwhile the menu is open — clicking the main action leaves the menu showing, and those keys have to\nbe able to dismiss it from there instead of walking focus away from it.\n\n`Spds::Action::Button::Filter::Quick` is unchanged — it is a toggle with no menu.\n\nArrow keys also skip options that an in-menu search (`@searchable`) has filtered out. Filtering only\nadds a `hidden` class, so those options stay registered; the engine now drops them from\n`navigableOptions`, and asks `optionElement(option)` which element carries that class so hosts whose\nsearch hides a wrapper rather than the option itself stay covered.\n\nTests and flows that used Tab to reach the next menu item should use `ArrowDown` / `ArrowUp`\ninstead."
    },
    {
      "id": "9.8.0-a-dismissed-toast-no-longer-holds-up-the-queue",
      "version": "9.8.0",
      "title": "A dismissed toast no longer holds up the queue",
      "date": "2026-08-20",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-485",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Feedback::Toast::Container"
      ],
      "capabilities": [],
      "services": [],
      "body": "Toasts still leave in the order they arrive, and a toast raised behind another still waits its turn before counting down. What changes is what happens when the toast in front leaves early: closing one by hand now releases the queue immediately, so the toast behind it starts its own countdown right away.\n\nPreviously the countdowns were serialized on a single queued task rather than on the queue itself. A toast dismissed by hand left its countdown pending, and the next toast's countdown was queued behind it — so the toast behind a hand-dismissed three-second toast sat there for three seconds past its own timeout, which read as a toast that had stopped working.\n\nNothing about the API changes. `timeout` means the same thing it always did, `0` still means \"stay until dismissed\", and toasts still stack from the bottom of the viewport in the order they arrive. Countdowns already survived a toast being moved into or out of a modal, and still do.\n\nApps that suppress auto-dismissal in their own tests by overriding `manageTimer` keep working; it is still the single, zero-argument place a countdown is started."
    },
    {
      "id": "9.8.0-toasts-show-the-time-they-have-left",
      "version": "9.8.0",
      "title": "Toasts show the time they have left",
      "date": "2026-08-20",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-485",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Feedback::Toast::Message"
      ],
      "capabilities": [],
      "services": [],
      "body": "A toast that dismisses itself now says so. The close button carries a circle in its own hover fill that sweeps away clockwise over the toast's `timeout`, so the toast reads as something on its way out rather than something that might stay.\n\nIt reflects the countdown that is actually running, not just the toast's `timeout`. Toasts leave in the order they arrive and only the one in front is on a timer, so a toast raised behind another shows nothing until its turn comes. A `timeout` of `0` — a toast that waits to be dismissed — shows nothing at all, and neither does a toast whose animations are turned off.\n\nMoving a toast into or out of a modal restarts CSS animations from nothing, so the sweep is resumed from where the countdown actually is rather than from a full circle.\n\nNothing to adopt: no new arguments, and the indicator follows from `timeout`, which toasts already carry. Under `prefers-reduced-motion: reduce` it is left out entirely, since a wedge that cannot sweep would misreport the time left, and the same goes for a browser too old to animate the sweep at all."
    },
    {
      "id": "9.8.0-update-ds-menus-to-use-the-native-popover-api",
      "version": "9.8.0",
      "title": "Update DS menus to use the native popover API",
      "date": "2026-08-20",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-485",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Action::Button::Dropdown",
        "Spds::Action::Button::Filter::Multiselect",
        "Spds::Action::Button::Filter::SingleSelect",
        "Spds::Action::Button::Split",
        "Spds::Core::Menu::Base",
        "Spds::Core::Popover",
        "Spds::Feedback::Tooltip",
        "Spds::Input::Dropdown::List",
        "Spds::Input::Search",
        "Spds::Menu::Filterable",
        "Spds::Menu::Multiselect",
        "Spds::Menu::Select"
      ],
      "capabilities": [],
      "services": [],
      "body": "Every DS menu now renders through the [native popover API](https://developer.mozilla.org/en-US/docs/Web/API/Popover_API), which paints it in the browser's top layer. A dropdown inside a modal, flyout, or any scroll container is no longer clipped by that container's overflow, and menus no longer need a `z-index` to sit above other content. This fixes the long-standing problem where a menu opened near the edge of a modal was cut off.\n\nMenus use `popover=\"manual\"` rather than `popover=\"auto\"`, so they keep their existing dismissal behavior and do not light-dismiss tooltips or toasts. Nothing about their position in the DOM changes, so descendant CSS selectors, click-outside handling, keyboard navigation, and test selectors continue to work.\n\n### Viewport-aware placement\n\nMenus now get the same edge detection tooltips have. A menu that would run off the bottom of the viewport renders above its trigger instead, and one that would run off a side edge shifts its horizontal alignment. Placement is recomputed as the page scrolls or the window resizes, so a menu opened near the middle of the page flips as its trigger approaches the bottom edge. A menu placed above its trigger also animates upward into place rather than downward.\n\nAn open menu also follows its trigger wherever it goes, not only when the page scrolls. A modal animating into place, a flyout sliding open, or content loading above the trigger all move it without the browser announcing anything, and a menu opened during any of those would otherwise keep the coordinates it measured before the movement finished — landing far from its trigger, or off-screen entirely, which looks like a menu that never opened. The menu now compares its trigger's position each frame while it is open and re-places itself when it has changed. As a last resort, a menu is confined to the viewport before it is painted: if something still places it out of bounds, it comes to rest against the edge rather than somewhere no one can see or click it.\n\n### New sizing and placement arguments\n\nMenus previously had to be sized and aligned by reaching into `.spds-menu` from a consuming app's stylesheet. Because JS now writes the menu's position directly, several of those rules would silently stop working, so the cases they covered are arguments instead:\n\n* `@width`, `@minWidth`, `@maxWidth` — the menu matches its anchor's width by default; these override and bound it.\n* `@maxHeight` — caps the scrollable list, which defaults to 368px.\n* `@placement` — where the menu prefers to sit, as `<side>-<alignment>`: `bottom-left` (default), `bottom-middle`, `bottom-right`, `top-left`, `top-middle`, or `top-right`. Viewport correction can still override it when the preferred placement would overflow.\n\n`@fitContent` still sizes a menu to its widest item, and now respects the min/max bounds instead of competing with them.\n\nThese reach every menu. `Spds::Menu::Select`, `Spds::Menu::Multiselect`, and the dropdown, filter, and split button menus take `@placement`, `@anchorOffset`, and the sizing arguments directly and forward them to `Spds::Menu::Filterable`. `Spds::Input::Dropdown::List` and `Spds::Input::Search` yield their menu, so pass the arguments to the yielded component. The buttons that render a menu internally — `Spds::Action::Button::Dropdown`, `Spds::Action::Button::Split`, and the filter buttons — take the same values prefixed: `@menuPlacement`, `@menuAnchorOffset`, `@menuWidth`, `@menuMinWidth`, `@menuMaxWidth`, and `@menuMaxHeight`.\n\n`Spds::Action::Button::Split` renders its own menu, so it takes `@menuPlacement` and passes it through as the menu's `@placement`. Its menu now anchors to the whole button rather than to the main half: the two were indistinguishable while every menu was left-aligned, but the main half stops short of the dropdown trigger, so `bottom-right` would have aligned to a seam in the middle of the control and `bottom-middle` would have centered off to one side. A split button menu that has no explicit width is now as wide as the whole control instead of the main half.\n\nSide placements (`left`, `right`) are intentionally not offered. A menu defaults to its anchor's width, which only reads as a dropdown above or below the anchor, and the horizontal correction described above has no vertical counterpart, so a tall menu placed beside its anchor would hang off the viewport with no way to recover.\n\n### If you style `.spds-menu` today\n\nRules that set `top`, `left`, `right`, `width`, `min-width`, `max-width`, or `max-height` on `.spds-menu` need to move:\n\n* `top` rules that nudged a menu below its trigger can be deleted outright — anchor-relative positioning computes this correctly now, and `@anchorOffset` tunes the gap when needed.\n* `left` / `right` rules used to force alignment become `@placement`.\n* Sizing rules become the arguments above, including when the value is conditional on app state — pass the condition's result in rather than styling around it. Setting `--spds-menu-width`, `--spds-menu-min-width`, `--spds-menu-max-width`, `--spds-menu-max-height`, or `--spds-popover-anchor-offset` from a stylesheet has no effect: the menu writes them inline, which no app rule can outrank.\n\nRules that style the menu's *contents* (`.spds-menu-list`, `.spds-menu-item`, `.spds-menu-no-results`) are unaffected.\n\n### If you snapshot menus in Percy\n\nPercy screenshots a re-render of the serialized DOM, and neither the top layer nor a popover's open state survives serialization — `showPopover()` never runs there. A menu's visibility does not depend on it: it shows and hides from the `open` class it renders for itself, which is in the markup Percy captures. No `percyCSS` is needed, and if you added the block an earlier build of this change asked for, delete it.\n\nPlacing the menu correctly is a separate problem. An open menu bakes viewport coordinates measured against the test container, which Percy's re-render throws away: it promotes the test content into `<body>`, so the anchor reflows to the top of the page while the menu keeps coordinates pointing at wherever the container used to sit. In a rendering test that container is pinned to the bottom-right corner, so the menu lands hundreds of pixels off, usually outside the captured region entirely.\n\nThe fix is to normalize the layout *before* serializing and let the menu re-measure against it. That preparation now ships with the addon as `test-support/helpers/percy`, which handles menus, tooltips, and toasts alike. The addon does not depend on the Percy SDK, so wire it into your own snapshot wrapper and take every snapshot of an open menu through that wrapper rather than calling `@percy/ember` directly:\n\n```js\nimport {\n  prepareSpdsSnapshot,\n  reparentOpenPopovers,\n} from 'ember-simplepractice/test-support/helpers/percy';\nimport basePercySnapshot from '@percy/ember';\n\nexport default async function percySnapshot(name, options) {\n  let restore = await prepareSpdsSnapshot();\n\n  try {\n    return await basePercySnapshot(name, { domTransformation: reparentOpenPopovers, ...options });\n  } finally {\n    restore();\n  }\n}\n```\n\nPass `{ freezeTransitions: true }` to also pin transitions and animations at their end state, for controls that would otherwise be captured mid-flight. `applyPercyLayout` and `resetPercyLayout` are exported too, for tests that need to measure against the render layout before asserting.\n\n`reparentOpenPopovers` covers a third problem: without the top layer, an ancestor with a transform becomes the menu's containing block, which displaces the menu and clips it out of the picture. Moving the menu to the root of the serialized DOM gives back the relationship the top layer provided — nothing between it and the viewport.\n\nA menu inside a modal is the exception, and the helper moves it *into* the modal instead. Percy's render reopens `<dialog open>` modally, which is why an SPDS modal still paints its backdrop there — and a modal dialog is in the top layer, above every `z-index`, so a menu left at the root is behind it no matter what it is given. Nested, the menu paints inside the modal's stacking context and travels with it, which also settles the geometry: a modal that sizes and centers itself in viewport units lands somewhere the capture never saw, and the helper positions the menu against the modal rather than the viewport so the overlap survives the move. Nothing in the test has to be arranged for Percy's sake.\n\n### Anchor offsets accept any CSS unit\n\n`@tooltipOffset` has been documented as accepting units other than pixels since tooltips shipped, but it was read with `parseInt`, so `0.5rem` silently resolved to `0` and only `px` ever worked. Offsets are now measured properly, and any CSS length resolves.\n\nThe menu's `@anchorOffset` (and `@menuAnchorOffset` on the components that forward it) is a CSS length for the same reason, where it was previously a bare number of pixels. Its default is unchanged at `4px`. Numbers still work and are read as pixels, but they fail type validation now, so `@anchorOffset={{8}}` becomes `@anchorOffset=\"8px\"`.\n\nFor menus the gap is applied by the stylesheet rather than baked into the position JS computes: `--spds-popover-anchor-top` and `--spds-popover-anchor-left` place the menu flush against its anchor, and `--spds-popover-anchor-offset` opens the gap from there. The browser resolves the unit, so the offset can be authored in any of them.\n\n### Browsers without the Popover API\n\nThe API arrived in Chrome and Edge 114, Safari 17, and Firefox 125, and some of our apps still declare support well below that — `simplepractice-video` down to Chrome 88 and Safari 14.1. Tooltips and toasts have quietly depended on popovers there for a while; menus made the exposure impossible to ignore, since a browser that cannot parse `:popover-open` throws away the whole rule it appears in — including the one that keeps a closed menu hidden, which paints the menu on the page instead.\n\nNo polyfill is involved. Every SPDS surface shows and hides from a class it renders for itself rather than from `:popover-open`, so those rules are valid CSS everywhere and a menu, tooltip, or toast opens and closes on an old browser exactly as it does on a new one. `Spds::Core::Popover` detects the API once and stands its calls down where it is missing, tracking the state itself so components read the same answer either way.\n\nWhat is lost is the top layer, which nothing in CSS or JS can reproduce. `core/popover.module.scss` substitutes a very high `z-index` under `@supports not selector(:popover-open)`, which does not escape an ancestor's `overflow` or a transformed ancestor's containing block — so on those browsers a menu inside a modal or a scroll container clips the way it did before this change, rather than gaining the fix. Entry and exit animation is skipped there too, since `@starting-style` and `transition-behavior: allow-discrete` are as new as the API itself, but each is ignored on its own rather than taking the rule down with it.\n\nIf your app styles a popover of its own, key its visible state on something it controls for the same reason, and keep `:popover-open` out of any selector list you cannot afford to lose.\n\n### Under the hood\n\nThe placement math tooltips have used is now a shared utility, `utils/spds/positioning`, consumed by both tooltips and menus. Placement constants moved from `utils/spds/constants/tooltip` to `utils/spds/constants/positioning`; the tooltip module re-exports them, so existing imports keep working.\n\nThe three surfaces that render in the top layer — `Spds::Core::Menu::Base`, `Spds::Feedback::Tooltip`, and `Spds::Feedback::Toast::Message` — now share a base class, `Spds::Core::Popover`. It declares no arguments of its own, so no component's API changes; what it owns is the behavior all three had grown their own copy of:\n\n* `showPopover` / `hidePopover`, wrapped with the connection and state checks each surface needed, reporting whether the element actually changed state so an exit animation can be sequenced off it. Its `isPopoverOpen` is the only place that reads `:popover-open`, which is what lets the feature detect above live in one spot: on a browser without the API, asking `matches(':popover-open')` is not a false match but a `SyntaxError`.\n* The anchored positioning pipeline — measuring the anchor, resolving a placement that fits the viewport, confining the result to it, publishing that, and following the anchor on a frame loop that repositions when its rect changes and when scroll or resize asks it to. Scroll and resize feed the same loop rather than scheduling work of their own, so a burst of them collapses into one reposition and tracking costs a single measurement per frame. The default publishes `--spds-popover-anchor-top`, `--spds-popover-anchor-left`, and `--spds-popover-anchor-offset` and lets `core/popover.module.scss` compose them under the `anchored` class; a surface that positions itself another way overrides `publishPosition` and opts out of that class, which is what the tooltip and the toast do.\n\n`ANCHORED_ARGS` collects `anchorElement`, `anchorOffset`, and `placement`, which previously lived in `MENU_ARGS` and were picked from there by the tooltip. Component-facing argument names are unchanged."
    },
    {
      "id": "9.7.1-fix-menu-item-click-target-for-highlighted-search-matches",
      "version": "9.7.1",
      "title": "Fix menu item click target for highlighted search matches",
      "date": "2026-08-17",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-567/output-value-is-empty-when-creating-modifier-rules",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Core::Menu::Item",
        "Spds::Input::Search",
        "Spds::Input::Dropdown::List"
      ],
      "capabilities": [],
      "services": [],
      "body": "Menu item click handlers now always receive the menu item itself as `event.target`, even when the click lands on content nested inside the item.\n\nFiltering a search or dropdown list wraps the matching portion of each option in a `<strong>` element to highlight it. Clicking directly on that bolded text made the `<strong>` the event target, so handlers reading `event.target.dataset.value` or `event.target.getAttribute('aria-selected')` — the documented way to identify the chosen option — got `undefined`. Consumers saw a selection that looked correct in the UI but carried no value, such as a claim edit rule saving with a blank modifier.\n\n`Spds::Core::Menu::Item` now forwards a proxy of the native click event that reports the item as `target`. Everything else on the event is untouched, so `currentTarget`, `preventDefault()`, and modifier keys behave as before, and consumers reading either `target` or `currentTarget` need no changes. Because the fix lives on the shared menu item, it also covers the select and filter menus and the dropdown and split action buttons."
    },
    {
      "id": "9.6.0-configurable-time-picker-minute-options",
      "version": "9.6.0",
      "title": "Configurable time picker minute options",
      "date": "2026-08-13",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/ENG-704/add-configurable-sub-hour-time-granularity-to-the-calendar",
      "tags": [],
      "components": [
        "Spds::Input::TimePicker"
      ],
      "capabilities": [],
      "services": [],
      "body": "`Spds::Input::TimePicker` accepts `@minuteOptions` so callers can offer minute increments other\nthan the default 15-minute grid (`['00', '15', '30', '45']`). Pass an array of two-digit minute\nstrings:\n\n```handlebars\n<Spds::Input::TimePicker\n  @minuteOptions={{array \"00\" \"05\" \"10\" \"15\" \"20\" \"25\" \"30\" \"35\" \"40\" \"45\" \"50\" \"55\"}}\n  @onSetTime={{this.setTime}}\n/>\n```\n\nThe default is unchanged. The lowercase `am`/`pm` time format also includes a space after the\nnumeral (`2:15 pm`) to match design-system date-and-time guidelines."
    },
    {
      "id": "9.5.0-route-aware-buttons",
      "version": "9.5.0",
      "title": "Route-aware buttons",
      "date": "2026-08-07",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-550",
      "tags": [
        "a11y",
        "routing"
      ],
      "components": [
        "Spds::Core::Button",
        "Spds::Action::Button::Variable"
      ],
      "capabilities": [],
      "services": [],
      "body": "Every SPDS button variant can now act as an Ember `LinkTo`. Provide `@route` and the button\nrenders as an `<a>` with a real `href`, keeping its variant styling:\n\n```handlebars\n<Spds::Action::Button::Primary @route=\"clients.show\" @model={{this.client}}>\n  View client\n</Spds::Action::Button::Primary>\n```\n\nThis replaces the two patterns teams reach for today: a `<LinkTo>` with `class=\"button primary\"`\nhand-copied from the design system, and `<Spds::Action::Button::Primary @tag=\"a\" href=...>`, which\nproduces a link with no routing behavior and the wrong `role`.\n\nAvailable on `Primary`, `Secondary`, `Tertiary`, `Ghost`, `Negative`, `Destructive`,\n`Promotional`, `Link`, and the `Agent::*` variants — every component extending\n`Spds::Core::Button`. Button types that shouldn't navigate (`Filter::*`, `Split::*`,\n`Dropdown::*`, `Close`, `Copy`) extend `Spds::Core::Base` instead and are unaffected.\n\n`Variable` also accepts the routing arguments and forwards them to whichever type it renders, since\nevery type it can delegate to is route-aware:\n\n```handlebars\n<Spds::Action::Button::Variable\n  @buttonType={{if this.isCurrent \"primary\" \"ghost\"}}\n  @route=\"styleguide\"\n  @query={{hash s=\"DS Actions\"}}\n/>\n```\n\nArguments:\n\n* `route` (string): target route name. Providing this is what turns the button into a link. An empty\n  string counts as absent, matching how every other SPDS string argument reads it.\n* `model` / `models`: dynamic segment values. Pass one or the other, not both.\n* `query` (object): query parameters. Passing `query` without a route — or alongside an empty one —\n  links to the current route.\n* `replace` (boolean): replace the current history entry instead of adding one.\n* `activeWhen` (array, string, or boolean): route name(s) that mark the link as active. An array of\n  route names is the preferred form; a space-separated string and a boolean that forces the state on\n  or off are both still accepted.\n* `activeClass` (string): class applied while the target route is active (default:\n  `spds-link-active`).\n\n`model` and `activeWhen` each accept several data types, so they carry a new `MULTIPLE` metadata\ntype. It renders as a `Multiple` tag in the styleguide API table and is deliberately excluded from\nthe validatable types: no assertion spans several types, and typing these narrowly would reject\nvalid values. Any component argument that legitimately accepts more than one type can use it, but\nnote that a `MULTIPLE` argument is skipped during validation entirely, so it cannot carry `forbids`\nor `requires` rules.\n\nBecause `href` is a real generated URL, browser link affordances work as users expect:\ncmd/ctrl-click opens a new tab, shift-click a new window, middle-click a background tab, and\n`target=\"_blank\"` opens a new tab. Pass `rel` explicitly alongside `target` — `target` is an HTML\nattribute rather than an argument, so the component can't inspect it to add\n`rel=\"noopener noreferrer\"` for you.\n\n`href` itself is the one attribute the component keeps for itself. A splatted `href` cannot override\nthe generated URL, and it cannot reintroduce one on a link that deliberately has none — so migrating\nan existing `@tag=\"a\" href={{...}}` button to `@route` can't leave a stale URL silently winning.\n\nRouting behavior is delegated to `LinkTo` rather than reimplemented, with two deliberate\ndifferences:\n\n* **No `role=\"button\"` in link mode.** Announcing an anchor as a button breaks link semantics and\n  Enter/Space expectations.\n* **`@disabled` renders `aria-disabled` with no `href`.** `LinkTo` checks for modified clicks and\n  `target` *before* it checks its own disabled state, so a disabled `LinkTo` still navigates on\n  cmd-click or with `target=\"_blank\"`. An anchor without an `href` is neither focusable nor exposed\n  as a link, which is the correct disabled semantic.\n\nOne authoring note: a nullish `@model` renders a non-navigating element and logs a warning rather\nthan the silent, clickable-but-dead `href=\"#\"` that `LinkTo` produces on its own. Guard the\nargument or omit `@route` until the model has loaded."
    },
    {
      "id": "9.4.0-standardize-animated-argument-for-ds-components",
      "version": "9.4.0",
      "title": "Standardize animated argument for DS components",
      "date": "2026-08-10",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-549",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Menu::Filterable",
        "Spds::Menu::Select",
        "Spds::Menu::Multiselect",
        "Spds::Action::Button::Dropdown",
        "Spds::Action::Button::Split",
        "Spds::Action::Button::Filter::Base",
        "Spds::Action::Button::Filter::Menu",
        "Spds::Action::Button::Filter::SingleSelect",
        "Spds::Action::Button::Filter::Multiselect",
        "Spds::Input::Search",
        "Spds::Input::Dropdown::List",
        "Spds::Feedback::Tooltip",
        "Spds::Feedback::FeatureBanner",
        "Spds::Feedback::AlertBanner::Message",
        "Spds::Indicator::LoadingOverlay"
      ],
      "capabilities": [],
      "services": [],
      "body": "Most animated DS components already exposed an `@animated` argument to toggle their\nanimations on and off, but several animated components did not. This release standardizes\n`@animated` across the remaining components so their animations can be disabled — useful for\nreduced-motion contexts and for stabilizing visual (Percy) snapshots.\n\nEvery listed component now accepts `@animated` (defaulting to `true`, so existing behavior is\nunchanged). Passing `@animated={{false}}` disables the animation.\n\n### Menu-composing components\n\nThe dropdown, split, and filter buttons, the search and dropdown-list inputs, and the\nunderlying `Spds::Menu::*` components now accept `@animated` and forward it down to the menu\nthey render. Previously the menu's open/close fade was hardcoded on for these consumers.\n\n### Fade / expand feedback components\n\n`Spds::Feedback::Tooltip`, `Spds::Feedback::FeatureBanner`,\n`Spds::Feedback::AlertBanner::Message`, and `Spds::Indicator::LoadingOverlay` gate their\nfade/expand transitions and keyframe animations behind `@animated`. When disabled, they also\nskip the exit-animation wait so show/hide is immediate. Alert banners dispatched through the\n`alertManager` service can set `animated` on the broadcast payload to control this per banner.\n\nNote: on `Spds::Feedback::FeatureBanner`, `@animated` is complementary to `@animateIn`.\n`@animateIn` controls only the entrance animation, while `@animated={{false}}` disables all\nanimation on the banner."
    },
    {
      "id": "9.3.0-add-character-limit-support-to-search-inputs",
      "version": "9.3.0",
      "title": "Add character limit support to search inputs",
      "date": "2026-07-31",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-513",
      "tags": [
        "DS Maintenance",
        "Incremental feature enhancement"
      ],
      "components": [
        "Spds::Input::Search",
        "Spds::Input::Search::Field",
        "Spds::Input::Search::Trigger",
        "Spds::Menu::Search",
        "Spds::Menu::Filterable",
        "Spds::Core::CharacterCounter",
        "Spds::Core::Input"
      ],
      "capabilities": [],
      "services": [],
      "body": "The search input family now supports a character limit, mirroring the existing behavior on `Spds::Input::Text`. Pass `@charLimit` and the field automatically renders a character counter and hard-caps typing at the limit via the native input `maxlength`. Consumers that want the cap without the visible counter can opt out with `@hideCharacterCounter`.\n\n## Why\n\n`ember-messaging-client` needs a bounded search/filter input, and the character-limit affordance already existed on the text input. This surfaces the same capability across the search components rather than reimplementing it per consumer.\n\n## Usage\n\n`@charLimit` is available on the search components and, when set to a positive number, both renders the counter beneath the field and enforces the cap:\n\n```hbs\n<Spds::Input::Search @charLimit={{50}} @value={{this.query}} @onChange={{this.onChange}} as |search|>\n  <search.trigger />\n  <search.menu as |menu|>\n    {{#each this.items as |item|}}\n      <menu.item @value={{item.value}}>{{item.label}}</menu.item>\n    {{/each}}\n  </search.menu>\n</Spds::Input::Search>\n```\n\n| Component | Arguments |\n| --- | --- |\n| `Spds::Input::Search` | `@charLimit`, `@hideCharacterCounter` |\n| `Spds::Input::Search::Field` | `@charLimit`, `@hideCharacterCounter` |\n| `Spds::Input::Search::Trigger` | `@charLimit`, `@hideCharacterCounter` |\n| `Spds::Menu::Search` | `@charLimit`, `@hideCharacterCounter` |\n| `Spds::Menu::Filterable` | `@searchCharLimit`, `@searchHideCharacterCounter` (forwarded to its in-menu search) |\n\nA `@charLimit` of `0` (the default) is treated as \"no limit\": no counter renders and no `maxlength` is applied. `Spds::Core::Input` now only emits `maxlength` when the value is greater than `0`, guarding against a `maxlength=\"0\"` that would otherwise silently block all typing.\n\n`@hideCharacterCounter` (default `false`) suppresses the counter while leaving the limit in force, for fields that are tight on vertical space or that surface the remaining-character affordance elsewhere. The cap is enforced whether or not the counter is visible, and the argument is inert on its own — with no positive `@charLimit` there is no counter to hide.\n\nBoth arguments are defined once in the `inputForm` shared argument collection (`utils/spds/metadata/shared-arguments`) and picked into each component, so their types and descriptions stay consistent across the API. `Spds::Menu::Filterable` picks both under a rename so its in-menu search arguments stay namespaced.\n\n## Internal changes\n\n- **Character counter typography.** `Spds::Core::CharacterCounter` now renders through `Spds::Typography::Caption` instead of `Spds::Core::Container`, aligning it with the typography system introduced in 9.0.0.\n- **`over` → `error` (breaking for consumers keying on the class).** The counter's over-limit state now uses the shared `error` state hoisted onto `Spds::Typography::Base` in 9.0.0, replacing the bespoke `over` class. The `data-test-spds-character-counter` hook is unchanged, but any test or style targeting `.over` on the character counter must switch to `.error`.\n- **Search field structure / menu anchoring.** `Spds::Input::Search::Field` renders the input row and the counter row as sibling roots rather than nesting them in a wrapping column. This keeps the input row a direct child of the consumer's container so menus continue to anchor and position correctly. `Spds::Menu::Search` now stacks its field in a column to match."
    },
    {
      "id": "9.2.0-introduce-skeleton-loading-component",
      "version": "9.2.0",
      "title": "Introduce skeleton loading component",
      "date": "2026-08-03",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-538/introduce-skeleton-loading-component",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Indicator::Skeleton"
      ],
      "capabilities": [],
      "services": [],
      "body": "Introduces `Spds::Indicator::Skeleton`, a DS-compliant placeholder that mimics\nthe shape of content while it loads. It promotes the styleguide-internal\n`placeholder-content` helper into a first-class SPDS component and adds an\non-by-default animation.\n\n## Usage\n\n```handlebars\n<Spds::Indicator::Skeleton @rowCount={{5}} />\n```\n\nThe component renders a header bar plus `@rowCount` body lines (default `3`).\n\n## Animation\n\n`@animated` (default `true`) is a single switch that gates BOTH the shimmer and\nthe fade transition:\n\n* **Default** (`@animated={{true}}`): the placeholder shimmers while visible and\n  fades in on appear. Pass `@when={{this.isLoading}}` to keep it mounted and fade\n  it out before it is removed from the DOM (mirrors `Spds::Indicator::LoadingOverlay`).\n* **Off** (`@animated={{false}}`): fully static with no shimmer and no fade; it\n  mounts and unmounts instantly.\n\nThe shimmer and fade both respect `prefers-reduced-motion`.\n\n## Notes\n\n* The body lines are marked `aria-hidden=\"true\"`.\n* `@rowCount` is a number argument; pass numeric values (e.g. `@rowCount={{5}}`)."
    },
    {
      "id": "9.1.0-introduce-tooltip-modifier",
      "version": "9.1.0",
      "title": "Introduce tooltip modifier",
      "date": "2026-08-03",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-545",
      "tags": [
        "DS Modifier"
      ],
      "components": [],
      "capabilities": [],
      "services": [
        "Tooltip"
      ],
      "body": "A new `{{spds-tooltip}}` modifier attaches a DS tooltip to any HTML element or Ember\ncomponent, without extending `Spds::Core::Base`, injecting the `spds/tooltip` service, or\nrendering `Spds::Feedback::Tooltip` and threading an `@anchorElement` reference. Apply the\nmodifier and provide the text:\n\n```handlebars\n<button type=\"button\" {{spds-tooltip content=\"Delete this item\"}}>\n  <Icon @name=\"trash\" />\n</button>\n```\n\nThe tooltip appears on hover and keyboard focus, and non-interactive anchors (e.g. a\n`<div>`) are made keyboard focusable automatically.\n\nArguments:\n\n* `content` (string, required): text displayed in the tooltip body.\n* `title` (string, optional): bold title displayed above the body text.\n* `placement` (string, optional): position relative to the anchor (default: `top-middle`; see the style guide for all values).\n* `offset` (string, optional): gap between the tooltip and its anchor (default: `8px`).\n\nThe modifier is a thin wrapper over the existing `spds/tooltip` service and\n`Spds::Feedback::Tooltip::Container`, so it inherits the same content standards (text\nonly), accessibility (`aria-describedby`, hover/focus, Escape dismissal), and automatic\nviewport-edge repositioning as the tooltip component."
    },
    {
      "id": "9.0.0-move-label-and-helper-text-into-typography",
      "version": "9.0.0",
      "title": "Move label and helper text into typography",
      "date": "2026-07-30",
      "type": "breaking",
      "issue": "https://linear.app/simplepractice/issue/DES-516",
      "tags": [
        "DS Component Creation",
        "a11y"
      ],
      "components": [
        "Spds::Typography::Base",
        "Spds::Typography::Label",
        "Spds::Typography::HelperText"
      ],
      "capabilities": [],
      "services": [],
      "body": "`Spds::Core::Label` and `Spds::Core::HelperText` now live in the `Spds::Typography`\ncollection as `Spds::Typography::Label` and `Spds::Typography::HelperText`. Update\ninvocations (`<Spds::Core::Label>` → `<Spds::Typography::Label>`) and imports\n(`ember-simplepractice/components/spds/core/label` → `.../typography/label`).\n\nBoth components now extend `Spds::Typography::Base`, so they gain the shared typography\nsurface (`@strong`, `@content`, `size` class mapping) and drop the tooltip args they\npreviously inherited from `Spds::Core::Base` (they are not tooltip anchors).\n\nThe reusable `@srOnly` (visually-hidden) and `@error` state capabilities have been hoisted\nonto `Spds::Typography::Base`, so **every** typography component — `Display`, `Heading`,\n`Body`, `Caption`, `Subtitle`, plus `Label` and `HelperText` — now supports `@srOnly` and\n`@error`.\n\nThe components keep their own templates, so the `data-test-spds-label` and\n`data-test-spds-helper-text` selectors and the emitted CSS classes are unchanged. Note that\nthe **value** of `data-test-spds-label` changes from `Spds::Core::Label` to\n`Spds::Typography::Label`; update any selector keyed on that value."
    },
    {
      "id": "8.13.0-introduce-typography-components",
      "version": "8.13.0",
      "title": "Introduce typography components",
      "date": "2026-07-13",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-503",
      "tags": [
        "DS Component Creation"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "Adds an `Spds::Typography` component collection to formalize DS typography patterns with reusable components.\n\nEach type style/size is its own component that composes `Spds::Core::Container`, renders a\nsensible default HTML tag, and sizes itself with the shared `$font-size-normal-*` rem\nvariables while pulling weight and line-height from `--token-font-*` custom properties.\n\n- **Display** — `Display::XLarge`, `Display::Large` (default `p`).\n- **Heading** — `Heading::XLarge` through `Heading::XXSmall` (default `h1`–`h6`, semibold).\n- **Body** — `Body::XLarge` through `Body::Small` (default `p`); pass `@strong` for semibold.\n- **Caption** — `Caption`, `Caption::Small` (default `span`); pass `@strong` for semibold.\n- **Subtitle** — `Subtitle` (default `span`, semibold, uppercase).\n\nThe rendered element can be overridden per usage via `@tag`, decoupling visual size from\nsemantic markup, and text can be supplied via block content or the `@content` argument.\n\nShips the normal (desktop/large-tablet) scale; the compact/mobile scale and responsive\nswitching are a planned follow-up."
    },
    {
      "id": "8.12.0-remove-deprecated-local-toast-methods",
      "version": "8.12.0",
      "title": "Remove deprecated local toast methods",
      "date": "2026-07-17",
      "type": "cleanup",
      "issue": "https://linear.app/simplepractice/issue/DES-522/remove-deprecated-local-toast-methods-from-ds-service",
      "tags": [],
      "components": [],
      "capabilities": [],
      "services": [
        "Spds::Toast"
      ],
      "body": "The `spds/toast` service no longer exposes the deprecated `local*` family of methods (`localError`, `localSuccess`, `localSystem`, and `fileUploadLocalToast`). These forwarded to their global counterparts and emitted a deprecation warning under the `spds.toast.local-methods` id.\n\nToasts render as `popover=\"manual\"` elements in the browser top layer via `Spds::Feedback::Toast::Container`, so they already stack above modals and other layered UI without a nested local container. A separate local toast API was therefore unnecessary. All consumer call sites were migrated in DES-425, so the methods are now removed along with their tests, style guide documentation, and the `spds.toast.local-methods` deprecation handling.\n\nUse the global methods instead: `error`, `success`, `system`, and `fileUploadToast`."
    },
    {
      "id": "8.11.0-introduce-multiselect-filter-button",
      "version": "8.11.0",
      "title": "Introduce multiselect filter button",
      "date": "2026-07-13",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/INS-1801",
      "tags": [
        "filter",
        "multiselect",
        "menu",
        "button"
      ],
      "components": [
        "Spds::Action::Button::Filter::Multiselect"
      ],
      "capabilities": [],
      "services": [],
      "body": "`Spds::Action::Button::Filter::Multiselect` is a filter button that opens a\n`Spds::Menu::Multiselect` dropdown, complementing the existing quick and single-select filter\nbuttons.\n\nThe trigger content is supplied through the `:label` block and the menu options through the\n`:menu` block, which yields the `item`, `expandableItem`, and `noResults` components from the\nunderlying multiselect menu. The button anchors the menu to itself, toggles it open on click, and\ncloses it on an outside click.\n\n- **Filtered state**: the `filtered` styling that marks an active filter defaults to whether a\n  selection exists and can be overridden with `@filtered`.\n- **Selection reporting**: `@onChange` receives `{ values }` whenever the selection changes.\n- **Menu configuration**: search (`@searchable`, `@searchPlaceholder`, `@searchThreshold`),\n  select-all (`@selectAllLabel`, `@selectAllMin`), the footer (`@onApply`, `@onClearAll`,\n  `@showClearAll`), `@subtitle`, and `@selected` are forwarded to the multiselect menu. Apply also\n  closes the menu.\n- **Trigger**: `@buttonType` (defaults to secondary), `@disabled`, `@fitContent`, and `@autofocus`\n  configure the button, and `@onClick` fires on trigger clicks."
    },
    {
      "id": "8.11.0-update-open-modals-through-the-modal-service",
      "version": "8.11.0",
      "title": "Update open modals through the modal service",
      "date": "2026-07-13",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-500/add-ability-to-update-modals-through-the-service",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Modal::Container::Global"
      ],
      "capabilities": [],
      "services": [
        "SpdsModal",
        "AlertManager"
      ],
      "body": "The `spds/modal` service now exposes an `update(modalId, params)` method for\npatching a modal that is already open. Rather than closing and re-opening a\nmodal to change its content, you can merge new params into the existing modal\nin place:\n\n```js\n@service('spds/moda') modal;\n\n...\n\nlet modalId = await this.modal.create({\n  modalComponent: 'transactional',\n  title: 'Saving…',\n  bodyText: 'Hang tight while we save your changes.',\n  primaryBtnText: 'OK',\n});\n\n// later, once the work finishes\nawait this.modal.update(modalId, {\n  title: 'Saved',\n  bodyText: 'Your changes were saved successfully.',\n});\n```\n\n`update` broadcasts the `update` variant of the modal event, which\n`Spds::Modal::Container::Global` handles by merging the supplied params over the\nmatching modal's existing configuration. Only the keys you pass are changed —\nuntouched params are preserved — and an unknown `modalId` is a no-op.\n\nThis brings the design system service to parity with the update behavior that\npreviously only existed on the deprecated `global-modal-container` service,\nclearing the way to fully retire that older service."
    },
    {
      "id": "8.11.0-consolidate-menus-and-restore-core-purity",
      "version": "8.11.0",
      "title": "Consolidate menus and restore core purity",
      "date": "2026-07-06",
      "type": "enhancement",
      "tags": [
        "menu",
        "multiselect",
        "architecture"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "The menu components have been reorganized so that `core` stays true to its name, the menu shell\nis decomposed into composable regions, and the two near-duplicate multiselect menus have been\nunified into one.\n\n### Core namespace purity\n\n`Spds::Core::Menu::Base` is now a minimal, dependency-free menu shell: it handles positioning and\nyields its content regions, nothing more. The in-menu search UI and the multiselect clear-filter\ncontrol have moved out of `core` (they depend on non-core components):\n\n- `Spds::Core::Menu::Search` → `Spds::Menu::Search`\n- `Spds::Core::Menu::Search::Input` → `Spds::Input::Search::Field`\n- `Spds::Core::MultiselectClearFilter` → `Spds::Input::MultiselectClearFilter`\n\nCSS hooks and `data-test-*` attributes are preserved, so downstream styling and tests are\nunaffected.\n\n### Composable menu regions\n\nRather than hard-coding its internal layout, `Spds::Core::Menu::Base` now yields three contextual\nregions so callers compose only what they need:\n\n- `Header` — a new `Spds::Core::Menu::Header`, pinned above the list.\n- `Body` — the scrollable option list plus the optional no-results state.\n- `Footer` — a new `Spds::Core::Menu::Footer`, pinned below the list, outside the scroll region.\n\nThe list body was extracted into a shared list component so that `Spds::Core::Menu::Base` and\n`Spds::Menu::Filterable` render identical list markup without duplication. The no-results state\n(`@noItemsDisplayed`, `@noResultsText`) continues to render in place of the list when empty.\n\n### Filterable menu\n\nSearch-enabled menu behavior now lives in the new `Spds::Menu::Filterable`, which extends\n`Spds::Core::Menu::Base` and adds the in-menu search field (`@searchable`, `@searchPlaceholder`,\n`@searchThreshold`). It surfaces the `:header`, `:body`, and `:footer` regions as named blocks, and\nthe field stays responsive while filtering is debounced (typing updates the input immediately;\nthe filter is applied once input settles). Single-select menus that expect built-in search now use\nthis component.\n\n### Unified automatic filtering\n\n`Spds::Menu::Filterable` is now the single source of truth for basic text-match filtering. The same\nmechanism backs both the in-menu search field and an external search term (`@searchValue`), so a\nterm hides non-matching options and highlights matches once, in one place, rather than each input\nre-implementing it:\n\n- automatic filtering is on by default (`@autoFilter`, default `true`);\n- an external term is applied immediately (the parent already controls typing cadence), while\n  in-menu typing debounces;\n- when only the item set changes while a filter is active (e.g. an async list gaining or losing\n  rows), the filter re-applies synchronously so filtered rows never flash back to the full list;\n- clearing the search, or closing the menu, reveals **only** the items the filter itself hid — a\n  consumer's own declarative `hidden` state is left untouched.\n\nCustom or async filtering opts out with `@autoFilter={{false}}` (or a custom `@filter`): the parent\nowns hiding, and each item highlights its own matches, so bolding still works. Highlighting is never\napplied twice — when `@autoFilter` is on, the menu highlights; when it is off, the item does.\n\n### Unified multiselect menu\n\n`Spds::Menu::Multiselect` replaces the two internal multiselect menus previously used by\n`Spds::Input::Dropdown::List` and `Spds::Input::Search`. It composes `Spds::Menu::Filterable`\nwith a checkbox group and adds:\n\n- an automatic \"Select all\" option gated by a configurable threshold,\n- an optional `expandableItem` — the new `Spds::Menu::Multiselect::ExpandableItem`, a checkbox with\n  a collapsible accordion of additional content (descriptive text, nested options, or any markup)\n  that auto-expands whenever that content matches the active search (auto-expansion always tracks the\n  search term; match highlighting follows `@autoFilter`). Manual toggles and search-driven expansion\n  share a single open state, and expanding scrolls the section's content into view so an item near\n  the bottom of the list is not hidden below the fold,\n- an opt-in footer with **Apply** and **Clear all** actions,\n- additive selection hooks (`@onSelectAll`, `@onClearAll`) that are independent of the\n  `@selectAll` behavior override.\n\n### Unified single-select menu\n\n`Spds::Menu::Select` replaces the two internal single-select menus previously used by\n`Spds::Input::Dropdown::List` and `Spds::Input::Search`, mirroring the multiselect merge. It\ncomposes `Spds::Menu::Filterable` and switches search source based on `@searchValue`:\n\n- without `@searchValue` (dropdown usage) it uses the built-in in-menu search\n  (`@searchable`, `@searchPlaceholder`, `@searchThreshold`);\n- with `@searchValue` (search-input usage) the parent owns filtering, the in-menu search is\n  suppressed, and matches are highlighted.\n\nThe mode-appropriate container class (`spds-input-dropdown-list-menu` / `spds-input-search-menu`),\nitem variant class (`spds-input-dropdown-list-item` / `spds-input-search-menu-item`), and the\n`data-test-*` hooks for both consumers are preserved, so downstream styling and tests are\nunaffected. As part of this, `Spds::Menu::Filterable` now honors `@noItemsDisplayed` when deciding\nto show the no-results state (previously only its own internal search count was considered).\n\n### Consumers migrated to the shared primitives\n\nThe menu-based components were re-pointed at the reorganized shell: the dropdown, filter, and split\naction-button menus render through `Spds::Menu::Filterable` and the new `:header`/`:body`/`:footer`\nregions, and the `Spds::Input::Dropdown::List` / `Spds::Input::Search` inputs now render through the\nunified `Spds::Menu::Select`. The filter action-button menu was also fixed to yield its options into\nthe `:body` region (it previously yielded into the default block, so its options did not render).\n`Spds::Input::Group::Checkbox` and the shared `menu-filter` utility were updated to back the unified\nmultiselect. These are internal composition changes; the public APIs of `Spds::Input::Dropdown::List`\nand `Spds::Input::Search` are unchanged."
    },
    {
      "id": "8.10.1-cleanup-ds-sass-variables-in-favor-of-custom-properties",
      "version": "8.10.1",
      "title": "Cleanup DS SASS variables in favor of custom properties",
      "date": "2026-06-25",
      "type": "cleanup",
      "issue": "https://linear.app/simplepractice/issue/DES-497/cleanup-ds-sass-variables-in-favor-of-custom-properties",
      "tags": [
        "DS Maintenance",
        "Internal"
      ],
      "components": [
        "Spds::Container::Accordion",
        "Spds::Core::Menu",
        "Spds::Input::Dropdown",
        "Spds::Input::TimePicker"
      ],
      "capabilities": [],
      "services": [],
      "body": "Replaces local SASS variables in SPDS component stylesheets with CSS custom properties. These variables were mostly used to compute values local to a given stylesheet (animation timings, spacing, and rhythm-based sizing), which tied those values to compile time. Moving them to custom properties lets the same values be recomputed at runtime, giving us greater flexibility for component presentation with no change to existing behavior.\n\nThe remaining SASS variable usage across SPDS components is now limited to shared font tokens (`$font-size-*` and `$font-family-percy`)."
    },
    {
      "id": "8.10.0-unify-ds-keyboard-navigation",
      "version": "8.10.0",
      "title": "Unify DS keyboard navigation",
      "date": "2026-06-25",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-486/unify-ds-keyboard-navigation",
      "tags": [
        "a11y",
        "keyboard navigation",
        "DS Maintenance",
        "internal"
      ],
      "components": [
        "Spds::Core::KeyboardNavigable",
        "Spds::Core::SelectableMenu",
        "Spds::Input::MenuParent",
        "Spds::Input::Search",
        "Spds::Input::Search::Trigger",
        "Spds::Input::Dropdown::List",
        "Spds::Action::Button::Filter::SingleSelect"
      ],
      "capabilities": [],
      "services": [],
      "body": "The design system previously carried two separate keyboard-navigation implementations — one for inputs (search/dropdown) and one for filter menu buttons. Maintaining both went against our principle of reuse over repetition, so they have been consolidated into a single, shared navigation engine.\n\n### What changed\n\nTwo abstract `Spds::Core` base components now provide the navigation behavior that consumers previously duplicated:\n\n- **`Spds::Core::KeyboardNavigable`** — a reusable arrow-key navigation engine for any component that exposes a list of focusable options behind an openable menu. It handles open/close on `ArrowUp`/`ArrowDown`/`Enter`, vertical movement (including `Tab`/`Shift+Tab`), optional horizontal traversal of auxiliary controls, `Enter` selection, and `Escape` to close. Active option focus is tracked via the `active` class and `element.focus()`, and the engine operates on a consumer-supplied `navigableOptions` list rather than querying the DOM.\n- **`Spds::Core::SelectableMenu`** — layers single-value selection on top of the navigation engine: a normalized tracked `value`, current-value bookkeeping, and the `aria-selected` selection writer. Components with a single selected value extend this instead.\n\nBehavior is tuned through small override hooks (`navigableOptions`, `allowHorizontalNavigation`, `leftNavigableOptions`, `rightNavigableOptions`, `horizontalAnchor`, `wrapAround`, `wrapAroundHorizontal`, `canEnterHorizontal`, `menuCanOpen`, `handleOpen`/`handleClose`, `exitToTrigger`, `optionElement`, `optionMatchesValue`, etc.) rather than by reimplementing key handling.\n\n### Horizontal navigation\n\nHorizontal navigation is now generalized in the same way as vertical navigation. Instead of a single hard-coded control on each side of an input, a component exposes arbitrarily-sized ordered lists via `leftNavigableOptions` and `rightNavigableOptions` (index 0 nearest the anchor). The anchor is dynamic — the active menu option when navigation started from the menu, otherwise the input/trigger — so `ArrowLeft`/`ArrowRight` step outward through a side, return to the anchor when moving inward past the first control, and stop at the outer edge (or wrap when `wrapAroundHorizontal` is enabled). Input consumers gate capture with `canEnterHorizontal` so arrow keys still move the caret until it reaches the field edge. The search and filter clear controls are now just the two-item case of this model.\n\n### Impact\n\nThe legacy `Spds::Input::KeyboardNavigable` and the filter-specific single-arrow-navigation implementations were removed, and the search/dropdown inputs and filter single-select button were migrated onto the unified bases. Behavior for existing consumers is unchanged; the win is a single navigation engine that new list/menu-style components can adopt without rebuilding keyboard support from scratch."
    },
    {
      "id": "8.9.0-argument-override-pattern-and-accurate-flex-fit-content-handling",
      "version": "8.9.0",
      "title": "Argument override pattern and accurate flex/fit-content handling",
      "date": "2026-06-17",
      "type": "enhancement",
      "tags": [
        "DS Maintenance",
        "Metadata"
      ],
      "components": [
        "Spds::Core::Base",
        "Spds::Core::Container"
      ],
      "capabilities": [],
      "services": [],
      "body": "This release introduces a reusable way to declare when one argument's value is silently\ndiscarded by another, and uses it to make `Spds::Core::Container`'s flex/`fit-content`\nhandling accurate and self-explanatory.\n\n### New: `Arg.overriddenBy(...)` authoring pattern\n\nDS authors can now declare, in component metadata, that an argument's value is overridden\n(silently ignored) when another argument is present:\n\n```js\nflex: Arg.string({ description: '...' }).overriddenBy([\n  { name: 'fitContent', reason: 'fit-content constrains both axes, so flex is ignored' },\n]),\n```\n\nUnlike `forbids` (which asserts/throws), this is **warn** severity — the value isn't illegal,\nit's just discarded — so it surfaces as a development/test-only console warning (deduped per\ncomponent instance) rather than an error. Entries support the same existence/`when` semantics\nas `forbids`/`requires`. The warning is wired into `Spds::Core::Base`'s `validateArguments`\nmodifier, so any component that includes `{{this.validateArguments}}` gets it for free.\n\nFor relationships that depend on runtime/CSS conditions a static `when` can't express, a\ncomponent may implement an `isArgumentOverridden(argName, entry)` hook that fully decides\nwhether the warning fires.\n\n### Container: accurate `@flex` vs `fit-content`\n\n`@flex` (the flex shorthand) makes a flex item fill its parent's main axis, which silently\ndefeats `width`/`height: fit-content` on that axis. The container previously discarded `@flex`\nin that case, but used its own `@column` as a proxy for the axis and treated every active\n`@flex` as conflicting. It now:\n\n- resolves the **parent's** true main axis (so the discard matches what actually renders), and\n- only treats `@flex` as conflicting when it actually makes the element non-content-sized\n  (`flex-grow > 0` or a non-`auto` basis).\n\nWhen `@flex` is genuinely overridden, a development warning now explains which `fit-content`\nargument discarded it and why.\n\n### Behavior changes\n\n- `@flex` values that stay content-sized (e.g. `flex: none`, `flex: initial`, or any\n  `grow: 0` / `basis: auto`) combined with a main-axis `fit-content` are **no longer\n  discarded** — they were never actually in conflict.\n- The individual flex longhand arguments (`@flexGrow`, `@flexBasis`, `@flexShrink`) now take\n  effect on the container (they are composed into the rendered flex). Previously they mapped\n  to CSS custom properties the container stylesheet did not consume, so they had no effect.\n- Providing an expanding `@flex` when the container's parent is **not** a flex layout now\n  emits a development warning (the flex has no effect in that case)."
    },
    {
      "id": "8.8.0-add-search-to-dropdown",
      "version": "8.8.0",
      "title": "Add search to dropdown",
      "date": "2026-06-24",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-386/add-search-to-dropdown",
      "tags": [
        "DS Maintenance",
        "Large Group Practice QoL Updates",
        "Incremental feature enhancement"
      ],
      "components": [
        "Spds::Action::Button::Dropdown",
        "Spds::Action::Button::Dropdown::Menu",
        "Spds::Core::Menu::Base",
        "Spds::Core::Menu::NoResults",
        "Spds::Core::Menu::Search",
        "Spds::Core::Menu::Search::Input",
        "Spds::Input::Dropdown::List",
        "Spds::Input::Dropdown::List::Menu",
        "Spds::Input::Dropdown::List::MultiselectMenu",
        "Spds::Input::Search",
        "Spds::Input::Search::Menu::Base",
        "Spds::Input::Search::Trigger"
      ],
      "capabilities": [],
      "services": [],
      "body": "Dropdown menus in DS components have been updated to include new search filter functionality. By default, this filter appears when 15 or more items are present in a menu, though this threshold is configurable.\n\n## Why\n\nPractices with large numbers of clinicians or clients would previously need to manually scroll through very large lists to find a clinician, client, or other list information. Now, they are able to filter the list items by typing into the search box, which acts as a sticky element at the top of the list when present.\n\n## Usage\n\nBy default, nothing needs to be done to get this working in the `Spds::Action::Button::Dropdown` or `Spds::Input::Dropdown::List` components. If a menu has 15 or more items in it, it will automatically display the search input, which is internally wired up and does not require outside configuration to properly filter the menu items.\n\nThe behavior can be customized with the following arguments, which are available on both `Spds::Action::Button::Dropdown` and `Spds::Input::Dropdown::List`:\n\n| Argument | Type | Description |\n| --- | --- | --- |\n| `@searchable` | boolean | Forces the search field on (`true`) or off (`false`), overriding the item-count threshold. When omitted, the field appears automatically once the threshold is met. |\n| `@searchThreshold` | number | Minimum number of items before the search field appears automatically. Defaults to `15`. |\n| `@searchPlaceholder` | string | Placeholder text shown in the search field. |\n| `@noResultsText` | string | Customizes the message shown when the active filter matches no items. Defaults to \"No matching results\". |\n\n### Behavior notes\n\n- **No results state:** When the active filter matches no items, a no-results message is displayed in place of the list (customizable via `@noResultsText`).\n- **Match highlighting:** Matching text within each item is bolded as the user types.\n- **Multiselect:** Filtering works in multiselect dropdown menus as well as single-select.\n\n## Internal modifications\n\nThe existing `Spds::Input::Search::Trigger` component has been generalized as the `Spds::Core::Menu::Search::Input` component, which allows for an identical search interface wherever this new core component is used. It has been inserted into the `Spds::Core::Menu::Base` component, which is the basis for all menus in the DS. See the [DS Core Menu](/styleguide?s=DS%20Core&ss=Menu) page for more information.\n\nThe `Spds::Input::Search::Trigger` refactor preserves its existing CSS class hooks (`spds-input-search-*`), so consumer styles and tests that target those classes are unaffected — this is not a breaking change.\n\nBecause `Spds::Core::Menu::Base` backs all DS menus, the in-menu search is explicitly disabled for `Spds::Input::Search`, which already provides its own trigger-based filtering. It can never render the in-menu search field, regardless of item count.\n\nThe `CloseOnClickOutside` modifier was updated to resolve containment using the event's composed path rather than the current target node. This makes \"click outside\" detection robust when an element inside the container (such as the search field's clear button) is removed from the DOM during the same click. This modifier is shared by modals and other dropdowns, so the improved behavior applies wherever it is used."
    },
    {
      "id": "8.7.1-fix-full-screen-modal-preview-pane-on-small-screen-sizes",
      "version": "8.7.1",
      "title": "Fix full screen modal preview pane on small screen sizes",
      "date": "2026-06-24",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-460/fix-full-screen-modal-preview-pane-on-small-screen-sizes",
      "tags": [
        "DS Maintenance"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "A change to how body width is calculated for the full screen modal on smaller screen sizes. The original requirements specified a minimum width of `624px`, which caused the preview pane to be forced out of the viewport at smaller screen sizes. This change leverages [container queries](https://developer.mozilla.org/en-US/docs/Web/CSS/Guides/Containment/Container_queries) to check the width of the parent and assign an appropriate width to the modal body, which allows both the body and preview pane to occupy the correct amount of the viewport."
    },
    {
      "id": "8.7.0-introduce-copy-button-component",
      "version": "8.7.0",
      "title": "Introduce copy button component",
      "date": "2026-06-23",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-487/introduce-copy-button-component",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Action::Button::Copy"
      ],
      "capabilities": [],
      "services": [],
      "body": "`Spds::Action::Button::Copy` is the canonical way to copy content to the user's clipboard, replacing the various one-off copy button implementations scattered across our apps.\n\nIt wraps `Spds::Action::Button::Variable`, so its appearance can be set to any DS button type via `@buttonType` (defaults to `secondary`).\n\n## Providing the content\n\nPass the value to copy directly with `@text`, or lazily with the `@getText` function (handy when the content is expensive to build or only known at click time). To also place a rich HTML flavor on the clipboard, provide `@html` (or `@getHtml`) alongside the plain text.\n\n```handlebars\n<Spds::Action::Button::Copy @text={{this.shareUrl}} />\n\n<Spds::Action::Button::Copy @getText={{this.buildSummary}} @buttonType=\"ghost\" />\n```\n\n## Behavior\n\n- Uses the native [Clipboard API](https://developer.mozilla.org/en-US/docs/Web/API/Clipboard) when available, falling back to `document.execCommand('copy')` for browsers without full support.\n- After a successful copy, the default label briefly swaps to `@copiedLabel` (\"Copied\") and a visually hidden live region announces the result to assistive technology.\n- If the copy fails, the label briefly swaps to `@copyErrorLabel` (\"Error copying to clipboard\"), the failure is announced to assistive technology, and the button is disabled until the error clears.\n- The block form yields the copied and error state for custom labels: `<Spds::Action::Button::Copy @text={{x}} as |state|>{{if state.copied \"Copied\" (if state.error \"Error\" \"Copy\")}}</Spds::Action::Button::Copy>`.\n- An optional `@onCopy` hook runs after a successful copy and can return a promise to extend the copied state. An optional `@onCopyError` hook is called with the error when a copy fails."
    },
    {
      "id": "8.6.1-address-missing-resource-links-in-the-style-guide",
      "version": "8.6.1",
      "title": "Address missing resource links in the style guide",
      "date": "2026-06-23",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-424/update-zh-links-in-component-metadata",
      "tags": [
        "Documentation",
        "Metadata"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "With the introduction of the metadata to DS components, there has been a large restructuring in the way data is served to the style guide. Each component now exports a metadata object that contains the data defining its API, the documentation shown in the style guide, and its resource links.\n\nThis fix addresses a few small issues that were resulting in many resource links not being displayed properly in the style guide:\n\n* Outdated links pointing to ZeroHeight directly instead of simplepractice.design\n* Missing Figma links\n* GitHub links being lost in metadata construction"
    },
    {
      "id": "8.5.0-introduce-toggle-input-component",
      "version": "8.5.0",
      "title": "Introduce toggle input component",
      "date": "2026-06-15",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-426/introduce-toggle-component",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Input::Toggle",
        "Spds::Input::Labeled::Base"
      ],
      "capabilities": [],
      "services": [],
      "body": "A new **Toggle** input component (`Spds::Input::Toggle`) renders an accessible,\nanimated on/off switch. Under the hood it is a labeled checkbox input, so it\nplugs into the existing `Spds::Input::Labeled::Base` plumbing and behaves like\nthe other SPDS form inputs.\n\n## Usage\n\n```gjs\n<Spds::Input::Toggle\n  @label=\"Email notifications\"\n  @checked={{this.notificationsEnabled}}\n  @onClick={{this.toggleNotifications}}\n/>\n```\n\nThe label can also be supplied as the default block or a named `label` block\ninstead of the `@label` argument.\n\n## Arguments\n\n* `@onClick` (required): handler invoked when the toggle is clicked.\n* `@onChange`, `@onBlur`, `@onFocus`: additional input event handlers.\n* `@checked` (default `false`): the toggle's on/off state.\n* `@label`: text label, with default/`label` block alternatives.\n* `@labelFirst` (default `false`): render the label before the input instead of\n  after.\n* `@size` (default `default`): one of `default`, `large`, `small`.\n* `@animated` (default `true`): animate the knob transition between states.\n* `@disabled`: render the toggle in a disabled state.\n* `@required`, `@value`, `@id`, `@gap` (default `8px`): standard labeled-input\n  arguments forwarded to the base.\n* `@tooltipContent` / `@tooltipPlacement` (default `top-left`): attach a tooltip\n  to the toggle, consistent with other SPDS components.\n\n## Supporting changes\n\n`Spds::Input::Labeled::Base` was extended to support the toggle's mask/label\nlayout, alongside small adjustments to the core container, input, and layout\nprimitives it relies on."
    },
    {
      "id": "8.4.0-introduce-loading-spinner-component",
      "version": "8.4.0",
      "title": "Introduce loading spinner component",
      "date": "2026-06-15",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-95/introduce-loading-spinner-component",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Indicator::LoadingSpinner",
        "Spds::Indicator::LoadingOverlay",
        "Spds::Feedback::LoadingOverlay::Container"
      ],
      "capabilities": [],
      "services": [
        "AlertManager",
        "Spds::LoadingOverlay"
      ],
      "body": "This introduces a family of loading indicators, plus a service and modifier for\nattaching loading states to arbitrary DOM elements.\n\n## Components\n\n1. **Loading spinner** (`Spds::Indicator::LoadingSpinner`) - the basic animated\n   spinner. Use it when the expected wait is more than a second, and keep only\n   one spinner visible on a page at a time.\n2. **Loading overlay** (`Spds::Indicator::LoadingOverlay`) - centers a spinner\n   over content with a backdrop that matches the modal backdrop color. It can\n   cover the full viewport (`@fixed={{true}}`) or be scoped to a specific DOM\n   element. A scoped overlay uses `position: absolute`, so its container **must**\n   be set up with `position: relative`.\n3. **Loading overlay container** (`Spds::Feedback::LoadingOverlay::Container`) -\n   like the containers for other SPDS components (toasts, tooltips), it registers\n   as a handler for events managed by the wrapper service around the\n   `alert-manager` service. A single instance lives at the application root.\n\n## Service\n\nThe new `spds/loading-overlay` service programmatically attaches loading states\nto arbitrary DOM elements by passing a reference to the element (or its `id`) to\nits `show` method. It also provides `update` for changing a rendered overlay's\noptions and `hide` for dismissing it. Calling `show` with no element (or options\nonly) renders a full-viewport overlay.\n\n```javascript\n// Element-scoped\nthis.spdsLoadingOverlay.show(this.listEl, { ariaLabel: 'Loading clients' });\nthis.spdsLoadingOverlay.hide(this.listEl);\n\n// Full-viewport\nthis.spdsLoadingOverlay.show();\nthis.spdsLoadingOverlay.hide();\n```\n\nThe service only ever broadcasts an `id` plus presentational options, never an\nelement reference. The container resolves the render target by `id` at render\ntime.\n\n## Modifier\n\n`{{spds-loading-overlay}}` is an ergonomic wrapper around the service that makes\nadding an overlay to an element trivial. Toggling its `loading` argument adds or\nremoves a loading overlay on whatever element the modifier is invoked on, without\ninjecting the service or threading element references through your component.\n\n```handlebars\n<div {{spds-loading-overlay loading=this.isSaving ariaLabel=\"Saving\"}}>\n  ...form...\n</div>\n```\n\nThe target element must be a positioned container (`position: relative`,\n`absolute`, or `fixed`). The modifier assigns an `id` to the element if one isn't\nalready present so the service can route show/hide events, and it calls `hide` on\nteardown.\n\n## Notes\n\n* The spinner accepts `@color` (default `neutral`) and `@size` (default\n  `medium`), and exposes an `@ariaLabel` (default `Loading`) for accessibility.\n  It renders with `role=\"status\"`.\n* The overlay forwards `@color` and `@ariaLabel` to its spinner and defaults the\n  spinner `@size` to `x-large`. Pass `@when={{this.isLoading}}` to keep the\n  overlay mounted and fade it out before it is removed from the DOM, or wrap it\n  in a conditional to mount/unmount it directly.\n* The `Spds::Feedback::LoadingOverlay::Container` must be present at the\n  application root for the service and modifier to work. It is already included\n  in the EHR application template."
    },
    {
      "id": "8.3.0-variable-button-component",
      "version": "8.3.0",
      "title": "Variable button component",
      "date": "2026-06-04",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-446/introduce-variable-button-component",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Action::Button::Dropdown",
        "Spds::Action::Button::Split",
        "Spds::Action::Button::Variable",
        "Spds::Action::Button::Filter::Trigger"
      ],
      "capabilities": [],
      "services": [],
      "body": "A new **Variable** button component renders any simple SPDS button type through a\nsingle `@buttonType` argument, instead of branching in a template to pick one\nbutton over another.\n\n## Why\n\nSeveral call sites need a button whose type changes based on a condition. Without\na variable button, that requires template logic to switch between, say, a\n`Primary` and a `Destructive` button even when every other argument is identical.\nThat bloats templates and duplicates the type-selection logic in multiple places.\n\n## Usage\n\n```gjs\n<Spds::Action::Button::Variable\n  @buttonType={{if @isDangerous \"destructive\" \"primary\"}}\n  @text=\"Save\"\n/>\n```\n\n`@buttonType` accepts any of the simple button types\n(`agent-ghost`, `agent-primary`, `agent-secondary`, `destructive`, `ghost`,\n`link`, `negative`, `primary`, `promotional`, `secondary`, `tertiary`) and falls\nback to `primary` when the value is unrecognized. Shared arguments\n(`@autofocus`, `@disabled`, `@text`, the `fitContent*`/`inline` container\noptions, and a block) are forwarded to the resolved button.\n\n## Internal simplification\n\nThe **split** button and the **dropdown**, **split**, and **filter** trigger\ncomponents now lean on the variable button for their type selection, removing the\nduplicated branching logic those components previously carried."
    },
    {
      "id": "8.2.0-release-note-section",
      "version": "8.2.0",
      "title": "Release note section",
      "date": "2026-06-04",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-461/add-a-release-notes-section-to-the-engineering-style-guide",
      "tags": [
        "styleguide",
        "documentation"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "The engineering style guide now has a **Release Notes** section for the\nSimplePractice Design System.\n\n## Authoring\n\nRelease notes live as markdown files in `addon/release-notes/*.md`. Each note\ncarries frontmatter (`version`, `title`, `date`, `type`, optional `tags`,\n`components`, and `services`) followed by a free-form markdown body. See the\n[authoring guide](https://github.com/SimplePractice/ember-simplepractice/blob/staging/addon/release-notes/README.md)\nfor the full field reference.\n\n## How it ships\n\n- `scripts/build-release-notes.mjs` aggregates the markdown into a generated\n  module (`utils/spds/release-notes-data.js`) before every addon build.\n- The style guide loads that module with a dynamic `import()`, so the archive is\n  code-split into its own chunk and never enters the main app bundle.\n\n## Browsing\n\nThe section renders each note as a card and can be filtered by **version**,\n**type**, **component**, **service**, and **tag**. Tags on a card are interactive and update\nthe matching filter when clicked. Each entry also has a **Copy link** action\nthat produces a shareable URL deep-linked to that release\n(`?s=Release Notes&release=<version>`) for posting in Slack or tickets."
    },
    {
      "id": "8.1.1-update-time-picker-component-to-match-ds-standards",
      "version": "8.1.1",
      "title": "Update time picker component to match DS standards",
      "date": "2026-05-28",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-443",
      "tags": [
        "DS Maintenance",
        "Internal"
      ],
      "components": [
        "Spds::Input::TimePicker"
      ],
      "capabilities": [],
      "services": [],
      "body": "Rebuilds the time picker on the shared DS core library and infrastructure while preserving its existing behavior."
    },
    {
      "id": "8.1.0-remove-metadata-library-generation-script",
      "version": "8.1.0",
      "title": "Remove metadata library generation script",
      "date": "2026-05-28",
      "type": "cleanup",
      "issue": "https://linear.app/simplepractice/issue/DES-442",
      "tags": [
        "DS Maintenance",
        "Internal"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "The metadata library generation script was an experiment in how to properly expose DS component metadata for LLM ingestion. We've discovered that the simple presence of the metadata objects in the component files seems to be enough in conjunction with the design-system skill written by @tkraak, so this code is unnecessary and can be wholly excised."
    },
    {
      "id": "8.0.0-simplify-mechanism-for-mapping-css-in-ds-components",
      "version": "8.0.0",
      "title": "Simplify mechanism for mapping CSS in DS components",
      "date": "2026-05-21",
      "type": "breaking",
      "issue": "https://linear.app/simplepractice/issue/DES-440",
      "tags": [
        "DS Maintenance",
        "Internal"
      ],
      "components": [
        "Spds::Action::Button",
        "Spds::Action::SegmentedControl",
        "Spds::Container::Accordion",
        "Spds::Container::Card",
        "Spds::Core::Base",
        "Spds::Core::Button",
        "Spds::Core::CharacterCounter",
        "Spds::Core::Container",
        "Spds::Core::HelperText",
        "Spds::Core::Input",
        "Spds::Core::Label",
        "Spds::Core::Menu",
        "Spds::Core::Modal",
        "Spds::Core::MultiselectClearFilter",
        "Spds::Feedback::AlertBanner",
        "Spds::Feedback::EmptyState",
        "Spds::Feedback::FeatureBanner",
        "Spds::Feedback::Toast",
        "Spds::Feedback::Tooltip",
        "Spds::Indicator::Badge",
        "Spds::Indicator::Tag",
        "Spds::Input::Dropdown",
        "Spds::Input::Group",
        "Spds::Input::Labeled",
        "Spds::Input::MenuParent",
        "Spds::Input::Search",
        "Spds::Modal::Flyout",
        "Spds::Modal::FullScreen"
      ],
      "capabilities": [],
      "services": [],
      "body": "This is a *breaking change* that's mostly an internal update, but it does affect some usage we’ve seen in the EHR where components extend `Spds::Core::Base`.\n\nFor background: that base component has a handy mechanism for mapping argument or internal attribute values to CSS classes or custom properties. Quick example: a Boolean `@hasBorder` can automatically add a has-border class when it’s true, without hand-rolling class logic in every template.\n\nPreviously, that depended on two internal arrays per concern — e.g. `classesToMapToArgs` and `classesToMapToAttrs` (and the same split for custom properties with `propsToMapToArgs` / `propsToMapToAttrs`). This required an additional decision point about where the component should look for each value.\n\nIn this release, we’ve leveraged some of the recent component metadata work to unify these lists into single arrays: `classesToMap` and `propsToMap`. The component resolves each entry the same way (`this[key] ?? this.args[key]`), so `args` and internal state can live in one list. For most app usage, nothing changes — the same `@hasBorder` argument still produces the same class. The win is for DS authors and anyone extending base components: less bookkeeping, clearer patterns, and updated wiki/docs."
    },
    {
      "id": "7.10.2-remove-max-width-from-feature-banner",
      "version": "7.10.2",
      "title": "Remove max width from feature banner",
      "date": "2026-05-20",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-444",
      "tags": [
        "DS Maintenance",
        "Internal"
      ],
      "components": [
        "Spds::Feedback::FeatureBanner"
      ],
      "capabilities": [],
      "services": [],
      "body": "`max-width` has been removed from the feature banner component, allowing it to flex to fill up all available width. This brings it more in line with the [simplepractice.design](https://www.simplepractice.design/1d0abbc0a/p/84e503-feature-banner/b/932965) guideline."
    },
    {
      "id": "7.10.1-apply-a-z-index-to-the-progress-bar-on-the-full-screen-modal",
      "version": "7.10.1",
      "title": "Apply a z-index to the progress bar on the full screen modal",
      "date": "2026-05-20",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-438",
      "tags": [
        "DS Maintenance",
        "Internal"
      ],
      "components": [
        "Spds::Modal::FullScreen"
      ],
      "capabilities": [],
      "services": [],
      "body": "`z-index` has been applied to the progress bar in the full screen modal header to prevent a layering issue where the body of the modal could sometimes partially cover the bar"
    },
    {
      "id": "7.10.0-introduce-a-design-system-architecture-skill",
      "version": "7.10.0",
      "title": "Introduce a design system architecture skill",
      "date": "2026-05-19",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-439",
      "tags": [
        "LLM Tooling"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "Adds a design-system architecture skill that teaches LLM tools how to build with core components, services, and DS patterns; trialed in the addon before moving to docker-dev.\n\nAlso adds a create-ds-component skill that sits on top of the architecture skill to allow creation of a new DS component by invoking the skill with a Linear issue URL."
    },
    {
      "id": "7.10.0-convert-toasts-to-use-the-popover-api",
      "version": "7.10.0",
      "title": "Convert toasts to use the popover API",
      "date": "2026-05-15",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-62",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Core::Base",
        "Spds::Core::Modal",
        "Spds::Feedback::Toast",
        "Spds::Modal::Acknowledgement",
        "Spds::Modal::Announcement",
        "Spds::Modal::Container",
        "Spds::Modal::Destructive",
        "Spds::Modal::Flyout",
        "Spds::Modal::FullScreen",
        "Spds::Modal::ImageCrop",
        "Spds::Modal::Standard",
        "Spds::Modal::Transactional",
        "Spds::Navigation::Tabs"
      ],
      "capabilities": [],
      "services": [
        "AlertBanner",
        "Modal",
        "Toast"
      ],
      "body": "Previously, we had two separate sets of methods defined, with some being needed to properly create toasts within modals (`local` prefix), and some being for general use. All of the `toast.local` methods have been deprecated in favor of the global methods! For now, the local methods are still in place, but under the hood they will be forwarding to the global methods and will trigger a deprecation warning in your dev console. This reduces our available toast API to four methods:\n\n* `error`\n* `fileUploadToast`\n* `success`\n* `system`\n\nSome background on this change: toasts are upgraded to use the [native popover API](https://developer.mozilla.org/en-US/docs/Web/API/Popover_API) to properly layer them on top of content, even open modals. Note that this may affect test selector usage as many tests were looking inside the toast container for the expected text, which will no longer work. Toasts are now either direct children of the document body, or of the topmost open modal, and all existing tests have been updated to reflect this change as part of this rollout.\n\nThe `spds/modal` service now automatically tracks the topmost open modal through its new `topmostOpenModal` attribute. This will change dynamically as DS modals open and close (they automatically register themselves with the service on creation).\n\nNote that directly calling `alertManager.broadcast` to create a toast is discouraged, as are the convenience methods that are only local to the EHR. Some of these will also trigger deprecations. Attempting to add a new `alertManager.broadcast('localToast', ...)` call will result in a hard error, as there are no longer any handlers registered for the associated events. Instead, the [spds/toast service](https://tr01.staging.simplepractice.com/styleguide?s=DS%20Services&ss=Toast%20service) should be used for all toast creation"
    },
    {
      "id": "7.9.0-promotional-variant-for-spds-action-button",
      "version": "7.9.0",
      "title": "Promotional variant for SPDS action button",
      "date": "2026-05-13",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-428",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Action::Button::Promotional"
      ],
      "capabilities": [],
      "services": [],
      "body": "Adds a promotional (green) variant of the action button across all existing button variants."
    },
    {
      "id": "7.8.0-ai-agent-variant-for-spds-action-button",
      "version": "7.8.0",
      "title": "AI agent variant for SPDS action button",
      "date": "2026-05-06",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-417",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Action::Button::Agent::Ghost",
        "Spds::Action::Button::Agent::Primary",
        "Spds::Action::Button::Agent::Secondary"
      ],
      "capabilities": [],
      "services": [],
      "body": "Adds an AI agent (plum) variant of the action button to indicate AI-driven actions, applied across all existing button variants."
    },
    {
      "id": "7.7.1-allow-search-input-external-update",
      "version": "7.7.1",
      "title": "Allow search input external update",
      "date": "2026-03-19",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-389",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Core::Menu",
        "Spds::Input::Dropdown",
        "Spds::Input::Group",
        "Spds::Input::MenuParent",
        "Spds::Input::Search"
      ],
      "capabilities": [],
      "services": [],
      "body": "Allows a search input's multi-select selections to be updated by passing in values through arguments instead of simply updating through user interaction."
    },
    {
      "id": "7.7.0-introduce-tooltip-component",
      "version": "7.7.0",
      "title": "Introduce tooltip component",
      "date": "2026-03-12",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-274",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Core::Base",
        "Spds::Feedback::Tooltip"
      ],
      "capabilities": [],
      "services": [
        "AlertManager",
        "Tooltip"
      ],
      "body": "This includes a few updates:\n\n* A new tooltip component which can easily be added to any DOM element by passing in a reference to the element as @anchorElement to the component\n* A new tooltip service for adding tooltips programmatically (this drives the next feature in the list)\n* Out of the box integration with all DS buttons, which now accept a @tooltipContent argument that automatically registers a tooltip for the button. This works for all existing buttons, so if you have any DS buttons that are wrapped in the legacy tooltip, it's a simple change to upgrade by passing the new argument and removing the legacy tooltip wrapper\n\nSome notes:\n\n1. [simplepractice.design](https://www.simplepractice.design/1d0abbc0a/p/89757c-tooltip/t/76ecdf6dad) sets hard limits on content type for tooltips, such that they only support text. Any HTML included should be for formatting purposes only. Interactive content is not supported\n2. DS buttons now accept the following arguments for customizing tooltip appearance:\n    * `@tooltipContent` (string, required): Body text displayed in the tooltip. Tooltips will not appear if no content is provided, even with the other arguments present\n    * `@tooltipOffset` (string, optional): Gap between tooltip and anchor (default: 8px, can accept other units)\n    * `@tooltipPlacement` (string, optional): Position relative to anchor (default: top-middle, see the style guide for all possible values)\n    * `@tooltipTitle` (string, optional): Heading displayed above the content\n\n3. Tooltips appear for both mouse hover and keyboard focus of the anchor element\n4. DS components other than buttons may partially support tooltips at this time, though full support will require an additional body of work to ensure\n5. Tooltips will automatically reposition to the opposite side of the anchor element if they are too close to the edge of the screen\n6. Tooltips use the browser native popover API under the hood, which means that they are rendered in the top layer of the DOM and so will always appear above other content. This guarantees that they will always be visible to the user as long as an element can be hovered or focused via keyboard nav (any elements in the main DOM flow are rendered inert when DS modals are open, and so cannot receive events)"
    },
    {
      "id": "7.6.10-update-existing-components-to-use-metadata",
      "version": "7.6.10",
      "title": "Update existing components to use metadata",
      "date": "2026-03-04",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-264",
      "tags": [
        "DS Maintenance",
        "Internal",
        "metadata",
        "styleguide",
        "documentation",
        "validations"
      ],
      "components": [
        "Spds::Action::Button",
        "Spds::Action::SegmentedControl",
        "Spds::Container::Accordion",
        "Spds::Container::Card",
        "Spds::Core::Base",
        "Spds::Core::Button",
        "Spds::Core::CharacterCounter",
        "Spds::Core::Container",
        "Spds::Core::HelperText",
        "Spds::Core::Input",
        "Spds::Core::Label",
        "Spds::Core::Menu",
        "Spds::Core::Modal",
        "Spds::Core::MultiselectClearFilter",
        "Spds::Feedback::AlertBanner",
        "Spds::Feedback::EmptyState",
        "Spds::Feedback::FeatureBanner",
        "Spds::Feedback::Toast",
        "Spds::Feedback::Tooltip",
        "Spds::Indicator::Badge",
        "Spds::Indicator::Tag",
        "Spds::Input::Dropdown",
        "Spds::Input::Group",
        "Spds::Input::Labeled",
        "Spds::Input::MenuParent",
        "Spds::Input::Search",
        "Spds::Modal::Flyout",
        "Spds::Modal::FullScreen",
        "Spds::Navigation::Tabs"
      ],
      "capabilities": [],
      "services": [],
      "body": "Components now each define a custom Metadata object that contains a detailed specification for the component's accepted arguments used to drive the component data validations, as well as documentation data for the engineering style guide.\n\nComponent metadata is also used by our LLM skills to let the tools understand how to use DS components to build features, or to build new DS components using our lower level patterns."
    },
    {
      "id": "7.5.1-fix-image-crop-modal",
      "version": "7.5.1",
      "title": "Fix Image Crop Modal",
      "date": "2025-12-18",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-287",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Core::Modal",
        "Spds::Modal::ImageCrop"
      ],
      "capabilities": [],
      "services": [],
      "body": "Converts the image crop modal to the SPDS standard modal so it can be accessed while an SPDS flyout is open."
    },
    {
      "id": "7.5.0-introduce-ds-split-button-component",
      "version": "7.5.0",
      "title": "Introduce DS split button component",
      "date": "2025-12-15",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-286",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Action::Button",
        "Spds::Core::Base",
        "Spds::Core::Button",
        "Spds::Core::Container"
      ],
      "capabilities": [],
      "services": [
        "AlertManager"
      ],
      "body": "Introduce a DS split button component with style guide documentation, intended to replace the legacy split-button implementation."
    },
    {
      "id": "7.4.0-update-new-spds-services-with-additional-functionality",
      "version": "7.4.0",
      "title": "Update new spds services with additional functionality",
      "date": "2025-12-10",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-298",
      "tags": [],
      "components": [
        "Spds::Feedback::Toast"
      ],
      "capabilities": [],
      "services": [
        "Modal",
        "Toast"
      ],
      "body": "Adds CTA data to the toast service and confirmation-modal shorthands (`confirm` and `destructiveConfirm`) to the modal service with overridable defaults."
    },
    {
      "id": "7.3.0-make-modals-deployable-through-alertmanager-service",
      "version": "7.3.0",
      "title": "Make modals deployable through alertManager service",
      "date": "2025-11-24",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-33",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Core::Modal",
        "Spds::Feedback::AlertBanner",
        "Spds::Feedback::Toast",
        "Spds::Modal::Container",
        "Spds::Modal::FullScreen"
      ],
      "capabilities": [],
      "services": [
        "AlertManager",
        "AlertBanner",
        "Modal",
        "Toast"
      ],
      "body": "Adds a modal container that renders modals generated through the `spds/modal` wrapper around the `alertManager` service, so any modal type can be created programmatically above page content."
    },
    {
      "id": "7.2.0-move-ds-badge-component-to-addon",
      "version": "7.2.0",
      "title": "Move DS badge component to addon",
      "date": "2025-11-21",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-267",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Indicator::Badge"
      ],
      "capabilities": [],
      "services": [],
      "body": "Moves the badge component into the `ember-simplepractice` addon. Previously these were added directly in the EHR."
    },
    {
      "id": "7.1.0-introduce-ds-accordion-component",
      "version": "7.1.0",
      "title": "Introduce DS Accordion Component",
      "date": "2025-11-19",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-260",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Action::Button",
        "Spds::Container::Accordion",
        "Spds::Container::Group",
        "Spds::Core::Base",
        "Spds::Core::Button",
        "Spds::Core::Container",
        "Spds::Feedback::AlertBanner",
        "Spds::Feedback::FeatureBanner",
        "Spds::Input::Group",
        "Spds::Input::KeyboardNavigable",
        "Spds::Layout::Variable",
        "Spds::Modal::FullScreen"
      ],
      "capabilities": [],
      "services": [],
      "body": "Introduces accordion and accordion group components with `onOpen`/`onClose` actions, a disabled state, and extensive layout customization, plus style guide documentation."
    },
    {
      "id": "7.0.1-availability-flyout-can-t-scroll",
      "version": "7.0.1",
      "title": "Availability flyout can't scroll",
      "date": "2025-11-14",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-263",
      "tags": [],
      "components": [
        "Spds::Modal::Flyout"
      ],
      "capabilities": [],
      "services": [],
      "body": "Fixes scrolling inside flyouts."
    },
    {
      "id": "6.9.0-introduce-ds-layout-components",
      "version": "6.9.0",
      "title": "Introduce DS Layout Components",
      "date": "2025-11-03",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-247",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Action::Button",
        "Spds::Action::SegmentedControl",
        "Spds::Container::Card",
        "Spds::Container::Group",
        "Spds::Core::Base",
        "Spds::Core::Button",
        "Spds::Core::Container",
        "Spds::Core::HelperText",
        "Spds::Core::Label",
        "Spds::Core::Menu",
        "Spds::Core::ProgressBar",
        "Spds::Feedback::AlertBanner",
        "Spds::Feedback::EmptyState",
        "Spds::Feedback::FeatureBanner",
        "Spds::Feedback::Toast",
        "Spds::Indicator::TagGroup",
        "Spds::Indicator::Tag",
        "Spds::Input::Checkbox",
        "Spds::Input::Dropdown",
        "Spds::Input::Labeled",
        "Spds::Input::Search",
        "Spds::Input::Text",
        "Spds::Layout::Flex",
        "Spds::Layout::Grid",
        "Spds::Modal::Announcement",
        "Spds::Modal::Flyout",
        "Spds::Modal::FullScreen",
        "Spds::Modal::Standard"
      ],
      "capabilities": [],
      "services": [],
      "body": "Adds design-system layout components (flex row/column and their reverse variants, plus a grid container) and extends the core container to support grid and CSS-custom-property-driven layout."
    },
    {
      "id": "6.8.1-account-for-fastboot-in-spds-components",
      "version": "6.8.1",
      "title": "Account for FastBoot in SPDS components",
      "date": "2025-10-23",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-236",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Core::Container",
        "Spds::Core::Modal",
        "Spds::Input::TimePicker"
      ],
      "capabilities": [],
      "services": [
        "BodyScrollManager"
      ],
      "body": "Guards SPDS components, modifiers, services, and utilities against missing `document` references so they work under FastBoot."
    },
    {
      "id": "6.7.4-character-counter-over-class-applied-too-early",
      "version": "6.7.4",
      "title": "Character counter over class applied too early",
      "date": "2025-09-19",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-205",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Core::CharacterCounter"
      ],
      "capabilities": [],
      "services": [],
      "body": "Fixes the character counter so the `over` styling only applies when the count exceeds the limit, not when it equals it."
    },
    {
      "id": "6.7.0-introduce-address-autocomplete-component",
      "version": "6.7.0",
      "title": "Introduce address autocomplete component",
      "date": "2025-08-28",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/CLMASST-522",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Action::Button",
        "Spds::Core::Menu",
        "Spds::Input::AddressAutocomplete",
        "Spds::Input::Dropdown",
        "Spds::Input::MenuParent",
        "Spds::Input::Search"
      ],
      "capabilities": [],
      "services": [],
      "body": "Adds a design-system version of the address autocomplete component."
    },
    {
      "id": "6.6.1-reorganize-ds-components",
      "version": "6.6.1",
      "title": "Reorganize DS components",
      "date": "2025-08-25",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-174",
      "tags": [
        "DS Maintenance",
        "Internal"
      ],
      "components": [
        "Spds::Action::SegmentedControl",
        "Spds::AlertBanner::Container",
        "Spds::AlertBanner::GlobalContainer",
        "Spds::AlertBanner::Message",
        "Spds::EmptyState::Body",
        "Spds::FeatureBanner::Body",
        "Spds::FeatureBanner::CtaContainer",
        "Spds::FeatureBanner::Header",
        "Spds::Feedback::AlertBanner",
        "Spds::Feedback::EmptyState",
        "Spds::Feedback::FeatureBanner",
        "Spds::Feedback::Toast",
        "Spds::Flyout::Body",
        "Spds::Flyout::Footer",
        "Spds::FullScreenModal::Header",
        "Spds::Indicator::TagGroup",
        "Spds::Indicator::Tag",
        "Spds::Input::TimePicker",
        "Spds::Modal::Acknowledgement",
        "Spds::Modal::Announcement",
        "Spds::Modal::Destructive",
        "Spds::Modal::Flyout",
        "Spds::Modal::FullScreen",
        "Spds::Modal::Standard",
        "Spds::Modal::Transactional",
        "Spds::Navigation::Tabs",
        "Spds::TimePicker::DoneBox",
        "Spds::TimePicker::Trigger",
        "Spds::Toast::Container",
        "Spds::Toast::Message"
      ],
      "capabilities": [],
      "services": [],
      "body": "Reorganizes the design-system components into folders that mirror zeroheight, using shell components so consuming apps keep working without immediate changes."
    },
    {
      "id": "6.6.0-introduce-dropdown-button-component",
      "version": "6.6.0",
      "title": "Introduce dropdown button component",
      "date": "2025-08-07",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/CLMASST-505",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Action::Button",
        "Spds::Core::Button",
        "Spds::Core::Menu",
        "Spds::Input::Dropdown",
        "Spds::Input::Text",
        "Spds::Toast::Message"
      ],
      "capabilities": [],
      "services": [],
      "body": "Adds a design-system dropdown button component, following the DS designs for its appearance."
    },
    {
      "id": "6.5.4-fix-button-disabled-state",
      "version": "6.5.4",
      "title": "Fix button disabled state",
      "date": "2025-07-21",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-152",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Action::Button",
        "Spds::Core::Button",
        "Spds::Core::Menu",
        "Spds::Input::Dropdown",
        "Spds::Input::Search"
      ],
      "capabilities": [],
      "services": [],
      "body": "Fixes the button disabled state so each button type matches the design specs."
    },
    {
      "id": "6.5.3-make-alertbanner-body-alignment-composable",
      "version": "6.5.3",
      "title": "Make AlertBanner body alignment composable",
      "date": "2025-07-14",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-155",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::AlertBanner::Message"
      ],
      "capabilities": [],
      "services": [],
      "body": "Adds `@bodyAlignment` and `@bodyTag` params to `Spds::AlertBanner::Message` to make the body layout composable."
    },
    {
      "id": "6.5.0-introduce-filter-button-component",
      "version": "6.5.0",
      "title": "Introduce filter button component",
      "date": "2025-07-07",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/ECD-197",
      "tags": [
        "DS Component Creation",
        "External Contribution"
      ],
      "components": [
        "Spds::Action::Button",
        "Spds::Core::Menu"
      ],
      "capabilities": [],
      "services": [],
      "body": "Adds the missing SPDS filter button component, aligned with the Figma designs, with default, hover, focus, and active states."
    },
    {
      "id": "6.4.2-ds-modal-stacking-order-issue-in-percy",
      "version": "6.4.2",
      "title": "DS modal stacking order issue in percy",
      "date": "2025-06-12",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-153",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Core::Modal",
        "Spds::Input::Labeled",
        "Spds::Modal::Announcement",
        "Spds::Modal::Standard"
      ],
      "capabilities": [],
      "services": [],
      "body": "Fixes a modal stacking-order issue surfaced in Percy visual tests."
    },
    {
      "id": "6.4.0-introduce-card-component",
      "version": "6.4.0",
      "title": "Introduce card component",
      "date": "2025-05-27",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/CLMASST-296",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Container::Card",
        "Spds::Container::Group::Card"
      ],
      "capabilities": [],
      "services": [],
      "body": "Adds a design-system card container built to the SPDS guidelines and Figma specs."
    },
    {
      "id": "6.3.0-introduce-button-components-to-spds",
      "version": "6.3.0",
      "title": "Introduce button components to SPDS",
      "date": "2025-05-21",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/CLMASST-263",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Action::Button",
        "Spds::AlertBanner::Message",
        "Spds::Core::Base",
        "Spds::Core::Button",
        "Spds::Flyout::Header",
        "Spds::FullScreenModal::Footer",
        "Spds::FullScreenModal::Header",
        "Spds::Input::Dropdown",
        "Spds::Input::Search",
        "Spds::Modal::Announcement",
        "Spds::Modal::Shared",
        "Spds::Modal::Standard",
        "Spds::TimePicker::DoneBox",
        "Spds::Toast::Message"
      ],
      "capabilities": [],
      "services": [],
      "body": "Adds the SPDS button family — primary, secondary, tertiary, ghost, negative, destructive, and close — so buttons are styled consistently and follow the design system guidelines.\n\nEach button type extends the `Spds::Core::Button` component, which houses all shared functionality. The specific button types act as preconfigured buttons with their own stylesheets."
    },
    {
      "id": "6.2.1-replace-color-tokens-in-time-picker",
      "version": "6.2.1",
      "title": "Replace color tokens in time picker",
      "date": "2025-05-09",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-144",
      "tags": [
        "Design Tokens H1"
      ],
      "components": [
        "Spds::TimePicker::DoneBox",
        "Spds::TimePicker::Trigger"
      ],
      "capabilities": [],
      "services": [],
      "body": "Replaces primitive color tokens in the time picker with alias and component tokens."
    },
    {
      "id": "6.1.2-use-zeroheight-api-to-feed-style-dictionary",
      "version": "6.1.2",
      "title": "Use zeroheight api to feed style dictionary",
      "date": "2025-04-23",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-129",
      "tags": [
        "Design Tokens"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "Feeds the style dictionary from the zeroheight API."
    },
    {
      "id": "6.0.4-make-updates-to-modals",
      "version": "6.0.4",
      "title": "Make updates to modals",
      "date": "2025-04-07",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-134",
      "tags": [
        "Full Screen Modal"
      ],
      "components": [
        "Spds::FullScreenModal::Footer",
        "Spds::Modal::Acknowledgement",
        "Spds::Modal::Announcement",
        "Spds::Modal::Destructive",
        "Spds::Modal::Shared",
        "Spds::Modal::Transactional"
      ],
      "capabilities": [],
      "services": [],
      "body": "Makes the full screen modal back button optional, adds a `disabled` option to the primary button, and adds a local toast container."
    },
    {
      "id": "6.0.2-fix-feature-banner-body",
      "version": "6.0.2",
      "title": "Fix feature banner body",
      "date": "2025-04-04",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-133",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::FeatureBanner::Body"
      ],
      "capabilities": [],
      "services": [],
      "body": "Fixes the feature banner body rendering."
    },
    {
      "id": "6.0.1-introduce-core-components",
      "version": "6.0.1",
      "title": "Introduce core components",
      "date": "2025-03-28",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-121",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::AlertBanner::Container",
        "Spds::AlertBanner::GlobalContainer",
        "Spds::AlertBanner::Message",
        "Spds::Core::Base",
        "Spds::Core::Button",
        "Spds::Core::CharacterCounter",
        "Spds::Core::Container",
        "Spds::Core::HelperText",
        "Spds::Core::Input",
        "Spds::Core::Label",
        "Spds::Core::Menu",
        "Spds::Core::Modal",
        "Spds::Core::MultiselectClearFilter",
        "Spds::Core::ProgressBar",
        "Spds::EmptyState::Body",
        "Spds::FeatureBanner::Body",
        "Spds::FeatureBanner::CtaContainer",
        "Spds::FeatureBanner::Header",
        "Spds::Flyout::Body",
        "Spds::Flyout::Footer",
        "Spds::Flyout::Header",
        "Spds::FullScreenModal::Body",
        "Spds::FullScreenModal::Footer",
        "Spds::FullScreenModal::Header",
        "Spds::FullScreenModal::Preview",
        "Spds::Input::Base",
        "Spds::Input::CharacterCounter",
        "Spds::Input::Checkbox",
        "Spds::Input::Dropdown",
        "Spds::Input::Group",
        "Spds::Input::KeyboardNavigable",
        "Spds::Input::Labeled",
        "Spds::Input::MenuParent",
        "Spds::Input::RadioButton",
        "Spds::Input::Search",
        "Spds::Input::Text",
        "Spds::Menu::Base",
        "Spds::Menu::Item",
        "Spds::Menu::NoResults",
        "Spds::Modal::Acknowledgement",
        "Spds::Modal::Announcement",
        "Spds::Modal::Destructive",
        "Spds::Modal::Shared",
        "Spds::Modal::Standard",
        "Spds::Modal::Transactional",
        "Spds::SegmentedControl::Button",
        "Spds::Shared::HelperText",
        "Spds::Shared::Label",
        "Spds::Shared::MultiselectClearFilter",
        "Spds::TimePicker::DoneBox",
        "Spds::TimePicker::Trigger",
        "Spds::Toast::Message"
      ],
      "capabilities": [],
      "services": [],
      "body": "Introduces `spds/core` — low-level, reusable building-block components and patterns that make it easier to compose new design-system and feature components."
    },
    {
      "id": "5.43.5-replace-color-tokens-in-modal",
      "version": "5.43.5",
      "title": "Replace color tokens in modal",
      "date": "2025-02-18",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-113",
      "tags": [
        "Design Tokens"
      ],
      "components": [
        "Spds::Modal::Announcement",
        "Spds::Modal::Shared",
        "Spds::Modal::Standard"
      ],
      "capabilities": [],
      "services": [],
      "body": "Replaces primitive color tokens in the modal components with alias and component tokens."
    },
    {
      "id": "5.43.2-replace-color-tokens-in-flyout",
      "version": "5.43.2",
      "title": "Replace color tokens in flyout",
      "date": "2025-02-12",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-97",
      "tags": [
        "Design Tokens"
      ],
      "components": [
        "Spds::Modal::Flyout"
      ],
      "capabilities": [],
      "services": [],
      "body": "Replaces primitive color tokens in the flyout with the new alias and component tokens."
    },
    {
      "id": "5.43.1-toast-positioning-needs-correction",
      "version": "5.43.1",
      "title": "Toast positioning needs correction",
      "date": "2025-02-11",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-109",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Toast::Container",
        "Spds::Toast::Message"
      ],
      "capabilities": [],
      "services": [],
      "body": "Corrects toast centering, which was most noticeable on mobile screen sizes."
    },
    {
      "id": "5.43.0-allow-customization-of-alert-banner-icon",
      "version": "5.43.0",
      "title": "Allow customization of alert banner icon",
      "date": "2025-02-11",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-110",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::AlertBanner::Message"
      ],
      "capabilities": [],
      "services": [],
      "body": "Allows the alert banner icon to be customized."
    },
    {
      "id": "5.42.5-ghost-button-clean-up",
      "version": "5.42.5",
      "title": "Ghost button clean-up",
      "date": "2025-02-09",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-98",
      "tags": [
        "Design Tokens"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "Updates ghost button color tokens (text, icon, and new bg-fill tokens) to clarify the button hierarchy across web and mobile."
    },
    {
      "id": "5.42.4-introduce-color-component-tokens",
      "version": "5.42.4",
      "title": "Introduce color component tokens",
      "date": "2025-02-04",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-72",
      "tags": [
        "Design Tokens"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "Adds color component tokens to the design token library."
    },
    {
      "id": "5.42.3-introduce-color-alias-tokens",
      "version": "5.42.3",
      "title": "Introduce color alias tokens",
      "date": "2025-01-28",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-71",
      "tags": [
        "Design Tokens"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "Adds the full set of color alias tokens (bg-surface, bg-fill, border, text, and icon) to the design token library."
    },
    {
      "id": "5.42.1-fix-full-screen-modal-resize-delay",
      "version": "5.42.1",
      "title": "Fix full screen modal resize delay",
      "date": "2025-01-22",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-94",
      "tags": [
        "DS Maintenance"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "Fixes a resize delay in the full screen modal's main content area by limiting the animation to the preview pane."
    },
    {
      "id": "5.42.0-introduce-search-input-component",
      "version": "5.42.0",
      "title": "Introduce search input component",
      "date": "2025-01-21",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-2",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Input::Base",
        "Spds::Input::Checkbox",
        "Spds::Input::Dropdown",
        "Spds::Input::Group",
        "Spds::Input::KeyboardNavigable",
        "Spds::Input::Labeled",
        "Spds::Input::MenuParent",
        "Spds::Input::RadioButton",
        "Spds::Input::Search",
        "Spds::Input::Text",
        "Spds::Menu::Base",
        "Spds::Menu::Item",
        "Spds::Menu::NoResults",
        "Spds::Shared::HelperText",
        "Spds::Shared::Label",
        "Spds::Shared::MultiselectClearFilter"
      ],
      "capabilities": [],
      "services": [],
      "body": "Introduces a dedicated search input component with basic and multiselect menus, supported states, in-field tags, and a `Select all` option."
    },
    {
      "id": "5.41.0-move-timepicker-component-into-ember-simplepractice",
      "version": "5.41.0",
      "title": "Move timepicker component into ember-simplepractice",
      "date": "2025-01-17",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-41",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::TimePicker::DoneBox",
        "Spds::TimePicker::Trigger"
      ],
      "capabilities": [],
      "services": [],
      "body": "Moves the time picker component into the `ember-simplepractice` addon so it can be reused across applications."
    },
    {
      "id": "5.40.1-fix-token-css-imports",
      "version": "5.40.1",
      "title": "Fix token CSS imports",
      "date": "2025-01-16",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-87",
      "tags": [
        "Design Tokens"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "Fixes CSS custom property duplication by importing `tokens.css` only in consuming apps rather than in the addon."
    },
    {
      "id": "5.39.6-publish-design-tokens-as-css-custom-properties",
      "version": "5.39.6",
      "title": "Publish design tokens as CSS custom properties",
      "date": "2025-01-13",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-69",
      "tags": [
        "Design Tokens"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "Publishes the design tokens as CSS custom properties, allowing for greater flexibility in stylesheets."
    },
    {
      "id": "5.39.5-radio-button-group-hover-states-not-properly-applied",
      "version": "5.39.5",
      "title": "Radio button group hover states not properly applied",
      "date": "2025-01-09",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-77",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Input::Base"
      ],
      "capabilities": [],
      "services": [],
      "body": "Fixes radio button group hover states not applying when the group has no selected value, by scoping the `:indeterminate` styles to checkboxes."
    },
    {
      "id": "5.39.1-update-personalization-colors",
      "version": "5.39.1",
      "title": "Update personalization colors",
      "date": "2025-01-06",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-5",
      "tags": [
        "Design Tokens"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "Updates calendar personalization colors to solid-only, replacing the old SCSS color functions with the proper primitive and component design tokens."
    },
    {
      "id": "5.36.1-update-personalization-colors",
      "version": "5.36.1",
      "title": "Update personalization colors",
      "date": "2024-12-09",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-5",
      "tags": [
        "Design Tokens"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "Updates calendar personalization colors to solid-only, replacing the old SCSS color functions with the proper primitive and component design tokens."
    },
    {
      "id": "5.36.0-introduce-new-modal-components",
      "version": "5.36.0",
      "title": "Introduce new modal components",
      "date": "2024-12-05",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-1",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Modal::Acknowledgement",
        "Spds::Modal::Announcement",
        "Spds::Modal::Destructive",
        "Spds::Modal::Shared",
        "Spds::Modal::Standard",
        "Spds::Modal::Transactional"
      ],
      "capabilities": [],
      "services": [],
      "body": "Introduces dedicated modal components (announcement, transactional, acknowledgement, and danger) with optional header, footer, and body regions, plus supporting options like `closeOnClickOutside` and `onBeforeClose`."
    },
    {
      "id": "5.35.0-introduce-air-color-alias-tokens",
      "version": "5.35.0",
      "title": "Introduce air color alias tokens",
      "date": "2024-11-13",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-4",
      "tags": [
        "Design Tokens"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "Adds the Air color alias tokens (icon, text, border, bg-fill, bg-surface, and bg-page) to the design token library."
    },
    {
      "id": "5.34.0-introduce-dropdown-input-component",
      "version": "5.34.0",
      "title": "Introduce dropdown input component",
      "date": "2024-11-06",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Input::Base",
        "Spds::Input::Checkbox",
        "Spds::Input::Dropdown",
        "Spds::Input::Group"
      ],
      "capabilities": [],
      "services": [],
      "body": "Introduce dropdown input component."
    },
    {
      "id": "5.33.0-introduce-segmented-control-component",
      "version": "5.33.0",
      "title": "Introduce segmented control component",
      "date": "2024-09-13",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::SegmentedControl::Button",
        "Spds::Toast::Message"
      ],
      "capabilities": [],
      "services": [],
      "body": "Introduce segmented control component."
    },
    {
      "id": "5.31.0-introduce-checkbox-group-component",
      "version": "5.31.0",
      "title": "Introduce Checkbox Group Component",
      "date": "2024-08-29",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Input::Base",
        "Spds::Input::Checkbox",
        "Spds::Input::Group"
      ],
      "capabilities": [],
      "services": [],
      "body": "Introduce Checkbox Group Component."
    },
    {
      "id": "5.29.0-introduce-text-input-component",
      "version": "5.29.0",
      "title": "Introduce text input component",
      "date": "2024-08-09",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Input::Base",
        "Spds::Input::CharacterCounter",
        "Spds::Input::Group",
        "Spds::Input::RadioButton",
        "Spds::Input::Text"
      ],
      "capabilities": [],
      "services": [],
      "body": "Introduce text input component."
    },
    {
      "id": "5.28.0-introduce-tag-component",
      "version": "5.28.0",
      "title": "Introduce Tag Component",
      "date": "2024-07-22",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Indicator::Tag",
        "Spds::Indicator::TagGroup"
      ],
      "capabilities": [],
      "services": [],
      "body": "Introduce Tag and Tag Group components."
    },
    {
      "id": "5.27.0-introduce-radio-button-component",
      "version": "5.27.0",
      "title": "Introduce radio button component",
      "date": "2024-07-10",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Input::Base",
        "Spds::Input::Checkbox",
        "Spds::Input::Group",
        "Spds::Input::RadioButton"
      ],
      "capabilities": [],
      "services": [],
      "body": "Introduce radio button component."
    },
    {
      "id": "5.26.0-introduce-checkbox-component",
      "version": "5.26.0",
      "title": "Introduce Checkbox Component",
      "date": "2024-06-03",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [],
      "capabilities": [],
      "services": [],
      "body": "Introduce Checkbox Component."
    },
    {
      "id": "5.25.0-introduce-empty-state-component",
      "version": "5.25.0",
      "title": "Introduce Empty State Component",
      "date": "2024-05-24",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Feedback::EmptyState",
        "Spds::Feedback::EmptyState::Body"
      ],
      "capabilities": [],
      "services": [],
      "body": "Introduce Empty State Component."
    },
    {
      "id": "5.24.0-introduce-full-screen-modal-component",
      "version": "5.24.0",
      "title": "Introduce Full Screen Modal Component",
      "date": "2024-05-14",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Modal::FullScreen",
        "Spds::Modal::FullScreen::Body",
        "Spds::Modal::FullScreen::Footer",
        "Spds::Modal::FullScreen::Header",
        "Spds::Modal::FullScreen::Preview"
      ],
      "capabilities": [],
      "services": [],
      "body": "Introduce Full Screen Modal Component."
    },
    {
      "id": "5.20.0-introduce-alert-banner-component",
      "version": "5.20.0",
      "title": "Introduce Alert Banner component",
      "date": "2024-04-26",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Feedback::AlertBanner::GlobalContainer",
        "Spds::Feedback::AlertBanner::Message",
        "Spds::Feedback::Toast::Container",
        "Spds::Feedback::Toast::Message"
      ],
      "capabilities": [],
      "services": [
        "AlertManager"
      ],
      "body": "Introduce Alert Banner component."
    },
    {
      "id": "5.16.9-introduce-new-flyout-component",
      "version": "5.16.9",
      "title": "Introduce new flyout component",
      "date": "2024-03-29",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Modal::Flyout",
        "Spds::Modal::Flyout::Body",
        "Spds::Modal::Flyout::Footer",
        "Spds::Modal::Flyout::Header"
      ],
      "capabilities": [],
      "services": [],
      "body": "Introduce new flyout component."
    },
    {
      "id": "5.16.4-introduce-new-toast-component",
      "version": "5.16.4",
      "title": "Introduce new toast component",
      "date": "2024-03-15",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Feedback::Toast::Container",
        "Spds::Feedback::Toast::Message"
      ],
      "capabilities": [],
      "services": [
        "AlertManager"
      ],
      "body": "Introduce new toast component."
    }
  ]
};
